import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080 845">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="">
          <path
            fill="#FEFFFF"
            opacity="1.000000"
            stroke="none"
            d="
M563.000000,846.000000 
	C375.357605,846.000000 188.215240,846.000000 1.036430,846.000000 
	C1.036430,564.394165 1.036430,282.788330 1.036430,1.091253 
	C360.892426,1.091253 720.784912,1.091253 1080.838623,1.091253 
	C1080.838623,282.666595 1080.838623,564.333313 1080.838623,846.000000 
	C908.454895,846.000000 735.977478,846.000000 563.000000,846.000000 
M404.714081,435.682800 
	C404.383392,435.529327 404.052734,435.375885 403.855865,435.140320 
	C403.855865,435.140320 403.780060,435.277832 403.710327,434.702393 
	C403.387848,434.525604 403.065338,434.348816 402.872437,434.170898 
	C402.872437,434.170898 402.771759,434.252472 402.886536,433.525238 
	C401.861298,432.019073 400.836060,430.512878 399.640747,428.788208 
	C399.640747,428.788208 399.766235,428.541412 399.917511,427.561554 
	C399.690735,424.067566 399.463959,420.573608 399.231689,416.360901 
	C399.409454,415.923798 399.587219,415.486725 400.325470,414.764130 
	C401.108307,412.294861 401.891174,409.825623 402.616821,407.168030 
	C402.616821,407.168030 402.725250,407.003754 403.346344,406.712036 
	C403.492798,406.081818 403.639221,405.451569 403.909149,404.972595 
	C403.909149,404.972595 403.749756,404.859833 404.412994,404.626404 
	C404.872955,403.339539 405.332947,402.052673 405.839600,400.864410 
	C405.839600,400.864410 405.732239,400.844940 406.434113,400.706512 
	C407.260010,399.077911 408.085876,397.449310 408.975861,395.364044 
	C408.975861,395.364044 409.287689,395.024323 409.906860,394.904999 
	C410.219269,394.206055 410.531677,393.507111 410.892853,392.894836 
	C410.892853,392.894836 410.793518,392.890900 411.474030,392.719727 
	C412.245636,391.403351 413.017212,390.086975 413.867828,388.866028 
	C413.867828,388.866028 413.745331,388.847351 414.397583,388.732819 
	C414.957367,387.654877 415.517151,386.576935 416.485504,384.924408 
	C425.979675,376.362732 434.675201,366.630707 445.139038,359.489960 
	C465.164001,345.824524 486.159698,333.575806 506.834656,320.872742 
	C511.539398,317.982056 516.062439,315.392731 518.371643,309.775330 
	C520.731262,304.035370 525.742432,301.785706 532.011597,301.520813 
	C536.077332,301.349030 540.363892,300.637939 544.087891,299.068451 
	C570.954895,287.745483 597.913330,276.797729 627.066650,272.701843 
	C629.931274,272.299377 631.739563,270.295258 630.577820,267.918274 
	C629.160461,265.018402 626.937866,261.984467 624.251709,260.313507 
	C595.717773,242.563828 566.999207,225.111160 538.404602,207.458405 
	C535.260742,205.517578 532.796509,205.643326 529.755127,207.598587 
	C519.259155,214.346222 508.652802,220.923935 498.035187,227.480026 
	C478.643524,239.453827 459.256287,251.436203 439.765686,263.247437 
	C435.621674,265.758667 433.827271,268.823730 433.883026,273.753601 
	C434.079102,291.079132 433.894073,308.408875 433.891144,325.737000 
	C433.890930,326.987732 434.191925,328.238525 434.371826,329.636322 
	C435.202148,329.462677 435.781708,329.512939 436.099670,329.248596 
	C439.546082,326.383148 442.833130,323.313873 446.387390,320.592377 
	C467.904999,304.116333 489.547913,287.802887 510.968842,271.202698 
	C514.367249,268.569092 517.463989,265.115936 519.630737,261.415466 
	C523.753479,254.374451 530.457703,251.316422 537.769470,254.134613 
	C543.908203,256.500702 547.503540,263.708984 545.966064,270.568085 
	C544.411011,277.505585 537.618286,281.750854 529.998596,281.154663 
	C527.233215,280.938293 523.941711,281.338776 521.606628,282.693024 
	C502.187073,293.955811 482.685852,305.111877 463.695892,317.072723 
	C440.239807,331.846649 418.665802,349.083282 400.182098,369.895020 
	C388.791595,382.720184 379.384888,396.733948 375.516083,413.835754 
	C373.829773,421.290070 373.395691,428.747742 375.995789,436.017670 
	C380.650818,449.033173 391.604156,453.739014 403.885132,454.131012 
	C413.688232,454.443909 423.580078,451.975494 434.183655,450.886688 
	C435.454102,450.256653 436.724579,449.626587 438.258026,448.766449 
	C438.258026,448.766449 438.604156,448.814667 439.415558,448.936584 
	C449.062225,445.410400 458.443115,441.381622 466.777008,435.372772 
	C466.587799,434.947876 466.398560,434.522980 466.209320,434.098083 
	C458.788727,436.847107 451.368134,439.596130 443.347778,442.731323 
	C442.880371,442.768768 442.412933,442.806213 441.611023,442.406433 
	C440.725739,442.667358 439.840454,442.928284 438.329132,443.550964 
	C437.853760,443.568237 437.378357,443.585541 436.229309,443.178192 
	C431.178772,443.376984 426.128235,443.575775 420.374298,443.874756 
	C419.934235,443.718353 419.494171,443.561951 418.909760,442.926453 
	C418.278015,442.931824 417.646240,442.937195 416.317047,442.945374 
	C415.892914,442.771667 415.468781,442.597961 414.811310,441.836487 
	C414.041656,441.629669 413.271973,441.422882 412.218872,441.281738 
	C412.218872,441.281738 412.008362,441.080872 411.724243,440.444794 
	C410.087250,439.684601 408.450256,438.924377 406.895660,438.063568 
	C406.895660,438.063568 406.878143,438.192413 406.733734,437.646545 
	C406.407928,437.493469 406.082092,437.340393 405.875702,437.125641 
	C405.875702,437.125641 405.815857,437.245972 405.720947,436.681580 
	C405.397186,436.517456 405.073456,436.353302 404.864502,436.135284 
	C404.864502,436.135284 404.812836,436.251129 404.714081,435.682800 
M656.544617,293.387268 
	C656.111755,293.957062 655.678894,294.526825 655.082642,295.084320 
	C655.082642,295.084320 655.094971,295.247742 654.460388,295.368256 
	C652.677490,297.244202 650.894592,299.120148 648.520142,301.307709 
	C647.028442,302.651276 645.536682,303.994843 643.448242,305.355774 
	C642.698425,306.243347 641.948608,307.130920 640.635803,308.396210 
	C639.447876,309.427185 638.259949,310.458160 636.529846,311.417542 
	C636.077393,311.960785 635.624939,312.504059 634.544312,313.303406 
	C633.387817,314.364075 632.231262,315.424744 630.523132,316.503143 
	C630.035461,317.001068 629.547852,317.498993 628.457275,318.180603 
	C627.992188,318.598175 627.527100,319.015747 626.492737,319.381042 
	C625.998901,319.910858 625.505005,320.440674 624.500610,321.158447 
	C624.356567,321.268524 624.212463,321.378632 623.467346,321.456482 
	C622.616211,322.276611 621.765076,323.096771 620.390808,324.106262 
	C620.289917,324.261841 620.188965,324.417419 619.448425,324.606964 
	C617.619446,326.052307 615.790466,327.497620 613.437439,329.048798 
	C613.311523,329.174927 613.185669,329.301086 612.508789,329.423065 
	C612.050415,329.959198 611.591980,330.495331 610.525452,331.238434 
	C610.062317,331.661804 609.599121,332.085175 608.566711,332.567078 
	C608.043701,333.032776 607.520691,333.498505 606.441345,334.205566 
	C606.327271,334.372498 606.213257,334.539429 605.555786,334.611786 
	C605.050415,335.070007 604.545044,335.528259 603.466614,336.204132 
	C602.994202,336.592773 602.521729,336.981415 601.485168,337.310242 
	C601.000427,337.867340 600.515747,338.424469 599.446838,339.125610 
	C599.329834,339.288452 599.212769,339.451294 598.445312,339.645599 
	C594.262085,342.731812 590.078857,345.818024 585.368164,349.012421 
	C585.267883,349.161255 585.167542,349.310120 584.509949,349.510468 
	C584.006653,349.995392 583.503296,350.480316 582.456482,351.120667 
	C582.330017,351.260406 582.203613,351.400116 581.536926,351.463715 
	C581.059509,351.981934 580.582092,352.500153 579.420654,353.213257 
	C578.317200,354.097778 577.213806,354.982330 575.491394,355.701935 
	C573.038513,357.478851 570.585693,359.255798 567.451294,361.138702 
	C566.003479,362.217438 564.555664,363.296143 562.460632,364.385895 
	C561.290771,365.236328 560.120911,366.086761 558.430786,367.079865 
	C558.309143,367.212372 558.187561,367.344849 557.494507,367.422668 
	C556.943909,367.905731 556.393311,368.388794 555.366272,368.954224 
	C555.366272,368.954224 555.035522,369.307037 554.360657,369.368439 
	C552.191101,371.614624 550.021545,373.860779 547.379395,376.630981 
	C547.230896,377.068848 547.082336,377.506714 546.418091,378.171997 
	C546.060669,378.796997 545.703308,379.422028 544.893677,380.524994 
	C544.303101,381.155579 543.712463,381.786194 542.485474,382.502411 
	C541.238708,383.270721 539.991943,384.039032 538.115845,384.757751 
	C537.722351,384.887329 537.328857,385.016907 536.230408,384.928711 
	C533.463135,384.445740 530.695862,383.962769 527.530640,383.095734 
	C527.351135,383.053589 527.171692,383.011414 526.768066,382.317688 
	C519.525452,374.970642 519.098206,370.781952 524.820984,360.854553 
	C524.820984,360.854553 524.867310,360.615723 525.582947,360.494873 
	C529.080078,359.354248 532.830444,356.799622 536.020874,357.371155 
	C542.407288,358.515259 547.190308,356.117706 552.852478,353.003540 
	C577.700745,338.899567 602.564697,324.823120 627.356506,310.620544 
	C628.783386,309.803131 630.543091,307.986481 630.585449,306.587555 
	C630.870972,297.161896 630.734192,287.723419 630.734192,278.320587 
	C629.722839,278.108215 629.223022,277.854950 628.788513,277.939056 
	C627.321472,278.223145 625.860901,278.570343 624.427307,278.993317 
	C598.213013,286.728088 574.077393,298.989777 550.874329,313.170471 
	C548.678284,314.512604 546.975769,317.535858 546.177368,320.127716 
	C543.764160,327.961548 536.528687,333.473969 529.332275,331.552185 
	C524.318420,330.213318 519.862976,330.949432 515.228516,332.611237 
	C489.235687,341.931671 465.669373,356.042542 441.711639,369.435333 
	C434.399139,373.523163 433.626373,383.197845 442.370270,387.559570 
	C471.844635,402.262360 500.975952,417.653839 530.200989,432.854004 
	C532.873718,434.244110 534.898560,434.297882 537.389771,432.281769 
	C568.652527,406.980988 600.295715,382.139771 631.202759,356.413452 
	C649.600342,341.099731 666.062256,323.656158 681.450684,304.623474 
	C681.799805,304.055420 682.148987,303.487335 683.007141,302.548309 
	C683.345764,302.024323 683.684387,301.500366 684.583008,300.849915 
	C684.941284,300.198425 685.299622,299.546936 686.183899,298.615845 
	C686.487854,298.112610 686.791809,297.609344 687.659668,296.956635 
	C688.019226,296.294861 688.378723,295.633057 689.165649,294.573669 
	C689.477966,294.088318 689.790283,293.602966 690.681213,292.924622 
	C691.275208,291.921814 691.869202,290.919006 692.850708,289.526520 
	C692.913940,289.354614 692.977173,289.182739 693.590637,288.887054 
	C693.897400,288.232239 694.204102,287.577454 694.943787,286.609741 
	C694.992432,286.438416 695.041138,286.267120 695.632385,285.909149 
	C695.978943,285.258514 696.325500,284.607910 697.090271,283.499817 
	C697.480957,282.786163 697.871643,282.072510 698.862915,281.066956 
	C700.804138,277.698547 702.745300,274.330139 705.021973,270.593140 
	C705.021973,270.593140 705.093628,270.099884 705.641357,269.804596 
	C706.201538,268.504486 706.761719,267.204407 707.743286,265.428589 
	C707.894043,265.038605 708.044861,264.648621 708.730469,263.868469 
	C709.886902,260.878571 711.043396,257.888702 712.657349,254.312592 
	C712.812317,253.590515 712.967224,252.868454 713.584778,251.880951 
	C713.704163,251.224457 713.823547,250.567947 714.284424,249.196045 
	C714.386841,248.426437 714.489258,247.656830 714.971497,246.539352 
	C714.965210,245.707840 714.958984,244.876312 715.157349,243.242737 
	C715.092590,242.147644 715.027832,241.052536 715.228882,239.377029 
	C714.538940,237.183334 713.848999,234.989639 713.084351,232.174988 
	C712.910950,231.803589 712.737549,231.432190 712.585205,230.462341 
	C711.694031,229.472122 710.802917,228.481903 709.601013,227.059021 
	C709.429932,227.011429 709.258911,226.963821 708.983582,226.298782 
	C708.325623,225.876312 707.667664,225.453857 706.999390,224.983673 
	C706.999390,224.983673 706.953247,224.999420 706.676819,224.408112 
	C703.415894,223.211349 700.154907,222.014587 696.292114,220.416306 
	C695.814270,220.445374 695.336426,220.474457 694.194702,220.082169 
	C688.186096,220.232483 682.177551,220.382782 675.389160,220.393158 
	C674.623413,220.534882 673.857666,220.676605 672.274414,220.611603 
	C660.757812,223.488998 649.241211,226.366379 637.216431,228.952148 
	C633.153992,230.350418 629.091553,231.748688 625.029053,233.146973 
	C625.242798,233.729431 625.456482,234.311890 625.670227,234.894348 
	C629.746277,233.464172 633.822388,232.033997 638.761353,230.425400 
	C645.650391,229.053329 652.539368,227.681259 659.975220,226.423203 
	C660.323059,226.306412 660.670837,226.189621 661.741394,226.344681 
	C665.149780,226.232346 668.558167,226.119995 672.633850,226.253296 
	C673.567139,226.322205 674.500366,226.391113 675.982971,226.881424 
	C679.033386,228.135178 682.083862,229.388916 685.148193,230.875977 
	C685.148193,230.875977 685.381470,230.861404 685.432922,231.439240 
	C685.944214,231.958786 686.455444,232.478333 687.184753,233.672256 
	C687.407349,234.084518 687.630005,234.496796 687.691895,235.526901 
	C688.011292,236.508118 688.330688,237.489334 688.572327,239.161270 
	C688.624023,240.316940 688.675781,241.472595 688.297363,243.016571 
	C688.182190,244.336716 688.067078,245.656845 687.709900,247.479996 
	C687.705017,247.848907 687.700134,248.217819 687.199402,248.893188 
	C687.065796,249.629395 686.932190,250.365585 686.342712,251.670959 
	C686.171753,252.373749 686.000793,253.076538 685.344421,254.052109 
	C685.200806,254.735474 685.057190,255.418839 684.450317,256.698151 
	C682.970764,259.496216 681.491211,262.294312 679.411499,265.270447 
	C678.510193,266.884338 677.608948,268.498199 676.215515,270.473541 
	C676.138916,270.662109 676.062378,270.850708 675.431824,271.116821 
	C675.127014,271.771423 674.822144,272.425995 674.004089,273.471680 
	C673.676270,274.018860 673.348450,274.566040 672.484314,275.351959 
	C671.903992,276.274139 671.323608,277.196289 670.234253,278.450043 
	C670.143311,278.631012 670.052429,278.811981 669.316895,279.101685 
	C667.993286,280.774963 666.669739,282.448273 665.128662,284.179565 
	C665.128662,284.179565 665.138184,284.404510 664.653015,284.556824 
	C664.312866,285.071655 663.972717,285.586517 663.087036,286.492065 
	C662.387146,287.355591 661.687195,288.219147 660.374573,289.232086 
	C659.328613,290.518158 658.282715,291.804230 657.073608,293.093262 
	C657.073608,293.093262 657.095947,293.254913 656.544617,293.387268 
M609.963135,530.500488 
	C609.960938,525.673584 610.029907,520.845398 609.938660,516.020203 
	C609.821960,509.852692 607.662781,507.575348 601.429932,507.473724 
	C591.778442,507.316345 582.121765,507.484863 572.470154,507.331055 
	C569.485107,507.283508 568.253540,508.314880 568.265930,511.318329 
	C568.329834,526.796265 568.342468,542.274780 568.276855,557.752686 
	C568.263611,560.870911 569.355347,562.227295 572.633972,562.175964 
	C582.452026,562.022278 592.275513,562.196228 602.092957,562.021667 
	C607.807922,561.920044 610.025757,559.381531 610.041443,553.470398 
	C610.060913,546.147095 609.994385,538.823547 609.963135,530.500488 
M517.489929,551.557007 
	C518.461060,550.306885 519.245056,548.200623 520.432739,547.940918 
	C530.718872,545.691406 532.987488,547.520264 533.231812,557.683838 
	C533.235779,557.850098 533.251099,558.018921 533.229980,558.182495 
	C532.821655,561.345276 534.519775,562.333801 537.347168,562.237122 
	C539.008545,562.180176 540.681152,562.113586 542.334656,562.237915 
	C545.463928,562.473206 546.410156,560.899841 546.324463,558.032410 
	C546.180481,553.212341 546.573669,548.343140 546.004333,543.582642 
	C545.707336,541.099060 543.832031,538.806763 542.683899,536.421204 
	C542.168579,535.350525 541.238708,534.251221 541.266541,533.184937 
	C541.426025,527.074524 541.884216,520.972717 542.105469,514.863037 
	C542.256775,510.683502 539.853455,507.858521 535.970703,507.720856 
	C525.733276,507.358032 515.474609,507.598114 505.025574,507.598114 
	C504.841217,509.350861 504.591827,510.646271 504.585846,511.942780 
	C504.518066,526.578735 504.666138,541.218872 504.348175,555.848938 
	C504.240295,560.811951 505.728210,562.425049 510.776581,562.359131 
	C515.578369,562.296448 518.111267,561.231750 517.365479,555.987366 
	C517.203552,554.848572 517.372742,553.662720 517.489929,551.557007 
M355.909943,535.624756 
	C348.630859,532.820862 341.279083,530.184387 334.131195,527.078491 
	C332.615875,526.420105 331.845276,524.047791 330.731567,522.465088 
	C332.231720,521.579346 333.693420,520.018433 335.239044,519.930359 
	C340.548004,519.627747 345.894989,519.656372 351.211182,519.906372 
	C357.197052,520.187866 355.570587,515.869812 355.856018,512.700500 
	C356.157410,509.353210 355.691772,506.917236 351.195923,507.114960 
	C343.052368,507.473022 334.884705,507.241028 326.732697,507.461243 
	C319.374420,507.660004 317.213318,510.071106 317.138672,517.632507 
	C317.114044,520.129089 317.105286,522.627869 317.179871,525.122986 
	C317.367279,531.391785 319.303497,534.141113 325.168396,536.299377 
	C331.091980,538.479248 337.129089,540.375610 342.941589,542.813293 
	C344.292633,543.379822 345.455597,545.567688 345.664032,547.146973 
	C345.755890,547.842957 343.276672,549.587280 341.911957,549.646851 
	C335.099274,549.944092 328.264496,550.006104 321.446564,549.820068 
	C316.704437,549.690674 317.067688,552.740173 317.131622,555.802063 
	C317.194672,558.823364 316.084015,562.412964 321.331909,562.326294 
	C331.482758,562.158508 341.648865,562.490295 351.782715,562.036499 
	C354.135803,561.931152 358.021790,559.851074 358.396454,558.084473 
	C359.958588,550.719177 361.526276,543.017822 355.909943,535.624756 
M274.498138,508.242188 
	C270.166260,508.264526 265.831818,508.388428 261.503357,508.277252 
	C257.995758,508.187195 256.670746,509.778595 257.100311,513.136902 
	C257.505554,516.304871 255.757080,520.701965 261.563873,520.702576 
	C266.728760,520.703125 271.907043,520.560486 277.051117,520.904358 
	C278.795441,521.020996 281.455933,522.044128 281.948669,523.325684 
	C283.084442,526.279419 280.700531,527.650330 278.069641,528.494995 
	C274.745087,529.562439 271.465454,530.777039 268.194794,532.003784 
	C253.289444,537.594299 252.268707,539.219116 253.632187,555.045227 
	C253.717484,556.035217 253.588104,557.316528 254.144073,557.941162 
	C255.700821,559.690063 257.519745,562.475281 259.314697,562.536987 
	C271.229279,562.946228 283.164673,562.748901 295.388794,562.748901 
	C295.493011,560.533264 295.448700,558.543274 295.705811,556.593018 
	C296.323975,551.903992 294.284943,550.535217 289.753448,550.790894 
	C283.442749,551.147034 277.091858,550.995056 270.769073,550.763306 
	C269.465881,550.715576 267.062012,549.180664 267.146637,548.643188 
	C267.410004,546.970520 268.233398,544.714966 269.548584,544.012207 
	C272.746307,542.303345 276.315094,541.256592 279.785278,540.095154 
	C295.860992,534.714783 296.372925,533.998230 295.633545,517.038574 
	C295.379944,511.221466 292.836456,508.579468 286.990479,508.339264 
	C283.163605,508.182037 279.326813,508.267700 274.498138,508.242188 
M784.755920,561.752625 
	C787.885010,561.882019 791.023804,562.196045 794.137573,562.032471 
	C795.121155,561.980896 796.864441,560.643921 796.858154,559.907166 
	C796.785828,551.448914 797.899658,542.604980 795.778748,534.641113 
	C793.472229,525.980347 788.202576,518.081299 784.003601,509.964630 
	C782.165527,506.411774 770.271973,505.785187 768.543884,509.267609 
	C761.603943,523.252686 752.373291,536.357544 754.620667,553.539185 
	C755.905701,563.363037 753.289124,562.134827 764.086121,562.283447 
	C766.969238,562.323120 768.205566,561.424805 768.336670,558.304871 
	C768.748230,548.514343 768.872314,548.519592 778.742188,548.720642 
	C778.908752,548.724060 779.076843,548.739136 779.241760,548.723389 
	C782.517456,548.411377 784.192749,549.532349 783.906555,553.184021 
	C783.701050,555.805847 784.102112,558.475098 784.755920,561.752625 
M642.231018,515.559509 
	C635.190918,527.277710 630.287842,539.382751 631.726135,553.659485 
	C632.668823,563.017395 631.909058,563.231934 641.422363,562.106873 
	C642.742004,561.950867 644.230103,560.097290 644.919067,558.679138 
	C645.511536,557.459534 645.226685,555.722778 645.063477,554.244080 
	C644.576599,549.834595 646.538574,548.111084 650.825073,548.615173 
	C651.975159,548.750427 653.154297,548.630554 654.319946,548.643250 
	C660.798523,548.713623 660.798462,548.715210 660.805420,555.398315 
	C660.812561,562.231689 660.812622,562.231689 666.988098,562.272705 
	C673.985840,562.319214 673.988342,562.319214 674.010376,555.076660 
	C674.015930,553.244812 674.106445,551.405029 673.972839,549.582458 
	C673.574707,544.152771 674.166016,538.340210 672.383362,533.393311 
	C669.529907,525.474426 665.177246,518.079163 661.213196,510.592285 
	C660.476929,509.201660 658.622192,507.560822 657.221436,507.501373 
	C648.208252,507.118988 646.605957,506.030975 642.231018,515.559509 
M482.373474,540.790527 
	C481.834106,538.046875 481.778656,535.086182 480.664032,532.600525 
	C477.399078,525.319641 473.478058,518.330811 470.272980,511.026154 
	C468.115417,506.108856 464.132690,507.509949 460.496735,507.260590 
	C457.133759,507.029999 454.429932,507.509125 452.806976,511.208710 
	C450.201813,517.147156 447.315308,522.990173 444.139954,528.644531 
	C438.141998,539.325012 441.650330,550.682617 440.497345,562.241577 
	C443.309113,562.241577 445.293884,562.052124 447.230103,562.278381 
	C452.321350,562.873230 453.944122,560.591919 453.837646,555.684021 
	C453.687927,548.786621 453.946686,548.780884 461.009674,548.773926 
	C462.009644,548.772949 463.023132,548.880737 464.007202,548.755737 
	C468.182159,548.225586 469.482941,550.060303 469.421387,554.159546 
	C469.292999,562.710449 469.479858,562.567261 478.016327,562.273254 
	C481.333252,562.159058 482.418762,560.756592 482.385498,557.720032 
	C482.327087,552.388611 482.383148,547.055969 482.373474,540.790527 
M709.935364,530.519653 
	C709.917908,538.179321 709.824585,545.839783 709.901978,553.498474 
	C710.001282,563.328674 708.333252,562.131287 719.178223,562.260620 
	C722.414917,562.299133 723.607727,561.154480 723.554688,557.898865 
	C723.397339,548.243469 723.515991,538.583862 723.433960,528.926758 
	C723.338989,517.746460 723.163269,519.569885 732.361877,519.903931 
	C737.668396,520.096558 737.769897,517.319641 737.879211,513.432129 
	C737.998047,509.206207 737.121399,506.962219 732.145691,507.123718 
	C721.832275,507.458344 711.493225,507.481537 701.180542,507.146423 
	C696.506287,506.994537 695.449219,508.825623 695.716553,512.978760 
	C695.952576,516.644714 694.935547,520.210876 701.026917,519.956543 
	C711.268555,519.529114 709.784241,518.929260 709.922119,528.523071 
	C709.926880,528.856079 709.928284,529.189148 709.935364,530.519653 
M396.505920,507.237549 
	C392.682465,507.251709 388.843658,507.075500 385.043854,507.382385 
	C383.697418,507.491119 381.655182,508.499390 381.279846,509.570007 
	C378.871643,516.439087 381.337463,519.740295 388.509338,519.757812 
	C389.008087,519.759033 389.517090,519.822693 390.003937,519.746338 
	C394.481628,519.044006 395.704041,521.069580 395.581329,525.367310 
	C395.301514,535.167542 395.425751,544.981384 395.494934,554.788879 
	C395.547668,562.268188 395.622253,562.267700 403.294647,562.314636 
	C403.460907,562.315674 403.629578,562.297241 403.793030,562.318909 
	C407.534515,562.815002 409.104889,561.575684 408.993011,557.424561 
	C408.711060,546.958923 409.239655,536.466064 408.787720,526.012512 
	C408.561035,520.768921 410.269196,519.462219 415.213165,519.678650 
	C423.453644,520.039368 423.259064,519.765076 423.256012,511.655853 
	C423.254608,507.919678 421.637512,507.194885 418.445679,507.246765 
	C411.466797,507.360199 404.484314,507.254059 396.505920,507.237549 
M577.490356,595.151184 
	C577.433105,603.477417 577.206787,611.808655 577.451416,620.126038 
	C577.504700,621.939392 579.241455,623.703247 580.202881,625.489868 
	C581.169006,623.844788 582.171814,622.219482 583.074402,620.540283 
	C583.290222,620.138977 583.029541,619.488525 583.233032,619.072571 
	C584.002991,617.498718 585.160095,614.575317 585.656250,614.676941 
	C587.639954,615.083130 589.836914,616.060364 591.190369,617.530273 
	C592.949768,619.441162 593.793640,622.170105 595.423462,624.238220 
	C596.037720,625.017639 597.997803,625.479492 598.877380,625.073730 
	C599.591125,624.744507 599.966003,622.859436 599.835754,621.740723 
	C599.690186,620.490417 598.931274,619.244995 598.218140,618.140259 
	C596.333984,615.221741 595.854431,612.776489 598.437012,609.640808 
	C600.062073,607.667664 600.712158,604.483215 600.859619,601.790771 
	C601.124573,596.950195 598.466675,592.856018 593.944397,592.004761 
	C588.953369,591.065308 583.618530,591.903320 578.440369,592.126648 
	C578.122375,592.140320 577.864624,593.551636 577.490356,595.151184 
M539.384949,605.617798 
	C534.868469,604.921570 536.507935,601.345703 536.697449,598.935364 
	C536.769958,598.012573 539.175415,596.764038 540.639282,596.567017 
	C543.581421,596.170898 546.640137,596.642944 549.583191,596.250244 
	C550.889587,596.076050 552.031982,594.672668 553.248779,593.827209 
	C551.983887,592.835083 550.760925,591.060547 549.446533,590.990051 
	C544.485107,590.723755 539.473267,590.787537 534.528625,591.247803 
	C533.285645,591.363403 531.278625,593.374939 531.227722,594.582825 
	C530.850891,603.536987 530.729004,612.511597 530.933167,621.470581 
	C530.966003,622.910828 532.905151,625.396667 534.163025,625.531372 
	C539.588501,626.112000 545.094116,626.168091 550.556091,625.984131 
	C551.582397,625.949585 552.542358,623.946716 553.532959,622.852173 
	C552.490662,622.030640 551.509521,620.614014 550.394653,620.499573 
	C547.103027,620.161743 543.750305,620.183105 540.436890,620.356567 
	C536.822571,620.545837 536.476807,618.489075 536.439514,615.642212 
	C536.401245,612.720032 537.359924,611.272705 540.454712,611.477600 
	C542.438843,611.609009 544.513611,611.772522 546.411499,611.333191 
	C547.769043,611.018860 548.900635,609.728516 550.133057,608.873657 
	C549.025085,607.886475 548.056824,606.371704 546.777161,606.032776 
	C544.740662,605.493530 542.496704,605.738098 539.384949,605.617798 
M783.668701,596.443542 
	C784.637573,595.380981 785.606445,594.318420 786.575317,593.255859 
	C785.439941,592.450134 784.338806,591.011475 783.163330,590.947998 
	C778.015686,590.670227 772.824951,590.527283 767.700012,590.947693 
	C766.380066,591.055908 764.234131,593.354858 764.185059,594.709717 
	C763.859924,603.684998 763.860840,612.681641 764.139526,621.659363 
	C764.183350,623.072815 766.058350,625.489014 767.284668,625.622498 
	C772.561279,626.196716 777.917786,626.273682 783.230652,626.095642 
	C784.415344,626.056030 785.540894,624.251892 786.693665,623.260132 
	C785.534058,622.328125 784.459167,620.755859 783.198242,620.588928 
	C779.917419,620.154663 776.552063,620.221863 773.225952,620.306335 
	C769.898499,620.390808 769.543030,618.423279 769.442139,615.786316 
	C769.331543,612.896606 770.167297,611.335083 773.343018,611.554932 
	C775.162842,611.680908 777.115173,611.871582 778.802856,611.358582 
	C780.431824,610.863403 781.797485,609.501892 783.278809,608.520996 
	C781.751343,607.554810 780.319214,606.338379 778.663879,605.707886 
	C777.500793,605.264771 776.020142,605.496338 774.705017,605.641663 
	C771.025024,606.048157 769.291443,604.937439 769.298035,600.779358 
	C769.304321,596.775574 771.387207,596.527405 774.343750,596.585632 
	C777.172302,596.641418 780.004639,596.508789 783.668701,596.443542 
M426.700348,615.771484 
	C417.088928,604.792908 418.224304,608.513855 426.300751,598.641418 
	C426.616241,598.255737 427.160126,597.959290 427.283325,597.530823 
	C427.820709,595.661743 428.241821,593.759216 428.705170,591.868835 
	C426.764862,592.580627 424.593719,592.958374 422.947632,594.095886 
	C421.216644,595.292053 420.037354,597.263428 418.526947,598.807983 
	C416.802338,600.571472 414.978424,602.237915 413.197662,603.946594 
	C412.721375,603.681335 412.245056,603.416077 411.768768,603.150818 
	C411.768768,600.215698 412.056061,597.238647 411.636932,594.364563 
	C411.451843,593.095459 409.833771,592.035217 408.866302,590.880188 
	C408.065765,592.012756 406.776550,593.063660 406.570770,594.295471 
	C406.192017,596.563354 406.440552,598.937500 406.444885,601.267395 
	C406.457916,608.255676 406.352875,615.248840 406.623108,622.227356 
	C406.667572,623.374878 408.374725,624.457886 409.313446,625.570740 
	C410.134552,624.511047 411.258698,623.560608 411.691132,622.360840 
	C412.119812,621.171448 411.597687,619.659363 411.947357,618.416748 
	C412.498291,616.458984 413.429810,614.608337 414.200195,612.712341 
	C415.796509,613.678833 417.626373,614.401611 418.941284,615.661804 
	C421.817566,618.418396 424.302917,621.589294 427.237549,624.274414 
	C428.057007,625.024231 429.887695,624.668884 431.254456,624.820557 
	C431.181244,623.498535 431.521423,621.945740 430.941284,620.906799 
	C429.990143,619.203369 428.441223,617.833618 426.700348,615.771484 
M241.656616,604.951172 
	C240.411987,604.481262 239.161896,604.025146 237.923904,603.538330 
	C235.765472,602.689575 232.743423,601.751343 234.637756,598.933716 
	C235.525833,597.612671 238.780579,597.711365 240.991516,597.542297 
	C241.786072,597.481567 242.606705,598.790649 243.520813,598.989014 
	C244.531128,599.208313 246.249893,599.247498 246.607056,598.690186 
	C247.183487,597.790894 247.412720,596.020203 246.889038,595.174683 
	C244.323517,591.032166 240.172501,590.680420 235.862991,591.304077 
	C231.619751,591.918274 228.911270,594.293762 228.299271,598.684387 
	C227.689850,603.056458 229.456345,606.106384 233.537125,607.805481 
	C235.838516,608.763733 238.406204,609.357239 240.361038,610.788330 
	C242.006790,611.993042 244.121811,614.371216 243.868530,615.863098 
	C243.596313,617.466431 240.971207,619.350647 239.064285,619.798401 
	C237.274307,620.218628 235.105103,618.791870 233.058548,618.423462 
	C231.392197,618.123535 229.660477,618.186829 227.957733,618.088989 
	C228.576462,619.795410 228.696243,622.120850 229.905060,623.095154 
	C233.949020,626.354553 239.037582,627.474182 243.363098,624.562439 
	C246.329254,622.565796 249.256165,618.893433 249.947098,615.509949 
	C251.005463,610.327209 247.099030,607.055786 241.656616,604.951172 
M831.471252,620.752319 
	C834.545837,613.200806 832.924988,608.793091 825.730469,605.359253 
	C824.087280,604.574951 822.106812,604.311890 820.710632,603.246643 
	C819.264526,602.143250 818.339783,600.356506 817.187012,598.868591 
	C819.076538,598.228027 820.930176,597.325439 822.871033,597.059692 
	C823.811096,596.930908 824.865967,598.241882 825.956787,598.458984 
	C827.271729,598.720642 828.680115,598.512817 830.048035,598.508179 
	C829.722717,597.019470 829.835815,595.189514 828.991516,594.104797 
	C826.226074,590.551697 819.823730,589.519287 815.883789,592.535095 
	C813.672546,594.227783 812.005798,597.294922 811.251221,600.058716 
	C810.319641,603.470947 812.453552,606.109436 815.705505,607.504089 
	C818.597046,608.744141 821.709656,609.563477 824.408691,611.117432 
	C825.720947,611.872803 827.084595,613.921997 827.013184,615.313049 
	C826.940308,616.734619 825.263184,619.083069 824.068359,619.229431 
	C821.526550,619.540710 818.843567,618.677307 816.215698,618.314941 
	C814.448730,618.071411 812.677063,617.861511 810.907471,617.636475 
	C811.617981,619.592896 811.752136,622.274048 813.140442,623.378113 
	C818.653748,627.762573 825.147583,626.826294 831.471252,620.752319 
M485.567078,601.122498 
	C487.091003,603.153687 488.266418,605.663330 490.228729,607.092529 
	C492.582031,608.806458 495.825806,609.272766 498.260254,610.909485 
	C499.790039,611.937988 501.542358,614.242676 501.362762,615.757629 
	C501.180756,617.292969 498.891754,619.456787 497.258850,619.725647 
	C495.083923,620.083801 492.666351,618.792358 490.324036,618.370239 
	C488.711700,618.079712 487.050262,618.061707 485.410797,617.921875 
	C485.984314,619.613159 486.091034,621.766479 487.220490,622.907471 
	C490.369843,626.089050 497.567444,626.472168 501.758789,624.091492 
	C505.313599,622.072327 507.565582,619.266724 507.476471,614.902710 
	C507.392639,610.798767 505.446625,607.964111 501.870575,606.240784 
	C499.486542,605.091919 496.820007,604.457825 494.589447,603.088989 
	C493.287170,602.289734 492.594269,600.497559 491.627197,599.152100 
	C493.117859,598.352722 494.538879,597.177795 496.123230,596.884033 
	C497.206665,596.683228 498.482483,597.935242 499.736115,598.132629 
	C501.293976,598.377991 502.917633,598.205444 504.512878,598.213379 
	C503.890717,596.481018 503.777679,594.147705 502.561066,593.117126 
	C496.231476,587.755066 486.792145,591.884277 485.567078,601.122498 
M361.174805,622.380432 
	C366.547852,625.875488 372.396393,626.758667 378.293030,624.425110 
	C380.075928,623.719604 382.564209,620.614441 382.183136,619.422241 
	C381.122406,616.103394 378.643829,618.144470 376.539551,619.100952 
	C370.992310,621.622559 364.850281,619.810181 361.594513,614.858215 
	C358.265656,609.795105 359.197113,603.960876 363.861206,599.589539 
	C367.628815,596.058350 371.877869,596.266296 376.477386,597.311340 
	C377.613129,597.569458 379.031433,596.584045 380.319855,596.170227 
	C379.684326,594.936096 379.269257,593.486938 378.342682,592.536621 
	C377.616821,591.792175 376.285980,591.543213 375.174957,591.284119 
	C367.842804,589.574707 359.406891,593.402649 356.108063,599.880920 
	C352.185608,607.583923 353.912415,616.083130 361.174805,622.380432 
M712.662598,602.226318 
	C712.769958,606.608765 711.951111,611.270508 713.171509,615.317261 
	C715.975525,624.615234 730.395386,628.975769 738.180054,623.267334 
	C739.205139,622.515686 739.381287,620.606323 739.950623,619.233154 
	C738.498230,618.984802 737.043762,618.542969 735.594116,618.557922 
	C734.670288,618.567444 733.772766,619.311890 732.830383,619.627991 
	C725.930725,621.942200 718.649414,617.657532 717.295654,610.507629 
	C715.625854,601.688721 723.064453,595.294739 732.579712,597.102112 
	C734.349487,597.438293 736.360046,596.506836 738.259521,596.160400 
	C736.819092,594.623657 735.659729,592.359070 733.889771,591.675598 
	C726.071167,588.656128 717.815430,592.689758 712.662598,602.226318 
M640.142944,612.899536 
	C639.104553,612.014038 637.614990,611.332825 637.105530,610.207825 
	C634.848389,605.223755 633.066650,600.018066 630.682983,595.101013 
	C629.918152,593.523315 627.832214,592.586121 626.350708,591.355896 
	C626.075317,593.264709 625.054504,595.454407 625.649902,597.035217 
	C628.692200,605.111816 632.065735,613.069092 635.541565,620.972168 
	C636.197693,622.463867 638.084961,624.701416 638.976807,624.517883 
	C640.539978,624.196289 642.363464,622.525391 643.044189,620.967896 
	C646.566467,612.909607 649.891785,604.756592 652.943787,596.510010 
	C653.464661,595.102417 652.327454,593.081177 651.956238,591.343445 
	C650.555420,592.463928 648.532898,593.298767 647.863525,594.755371 
	C645.232178,600.481384 643.026794,606.403259 640.142944,612.899536 
M278.272797,592.672546 
	C274.922668,589.829895 273.365021,591.537842 273.299072,595.000183 
	C273.131073,603.822815 273.063538,612.660889 273.471344,621.468811 
	C273.547028,623.103577 275.897766,625.810669 277.429962,625.984741 
	C282.525421,626.563416 287.738007,626.399109 292.877869,626.076233 
	C294.022552,626.004272 295.053497,624.121765 296.136810,623.072876 
	C295.078339,622.213135 294.114655,620.811829 292.941650,620.606506 
	C290.510406,620.181030 287.968231,620.376160 285.471283,620.342590 
	C279.261108,620.259155 278.897522,619.923340 278.823425,613.894714 
	C278.739563,607.069214 278.677490,600.243469 278.272797,592.672546 
M323.480255,617.100037 
	C322.970917,618.245422 322.422180,619.375305 321.963013,620.540405 
	C321.471252,621.788147 320.528717,623.203796 320.802002,624.289734 
	C320.993744,625.051697 322.847870,625.604187 324.041870,625.848328 
	C325.313721,626.108337 326.709442,626.058472 328.001221,625.843811 
	C329.375610,625.615540 331.277893,625.405701 331.852936,624.495239 
	C332.338531,623.726379 331.277771,621.959656 330.860382,620.647583 
	C330.379456,619.135559 329.496643,617.656677 329.416504,616.130371 
	C329.208099,612.161865 329.051514,608.146667 329.438477,604.205444 
	C329.725067,601.286316 330.631714,598.345703 331.747192,595.612732 
	C332.920197,592.738831 331.884430,590.691101 328.662476,590.714661 
	C326.844666,590.727966 325.020172,590.908936 323.213531,591.133606 
	C320.021790,591.530640 320.031586,593.134644 321.311737,595.651184 
	C322.354523,597.700989 323.315369,600.004578 323.465515,602.252197 
	C323.774139,606.872253 323.515686,611.530212 323.480255,617.100037 
M686.464722,606.543701 
	C686.862488,602.592957 685.062500,598.188538 688.924561,594.857910 
	C689.112122,594.696228 687.740845,591.706787 686.625122,591.288391 
	C684.864136,590.627991 682.682007,590.824768 680.717712,591.032532 
	C677.558960,591.366516 676.738464,592.815613 678.584961,595.761169 
	C679.710144,597.556213 680.643982,599.726379 680.827209,601.801941 
	C681.176819,605.761536 681.239807,609.807434 680.815125,613.752258 
	C680.544006,616.270996 679.088379,618.644531 678.353882,621.139160 
	C678.017029,622.283447 678.137512,623.562378 678.050537,624.780212 
	C681.429749,625.012268 684.808960,625.340332 688.188232,625.341248 
	C688.563416,625.341370 689.528625,622.857361 689.226318,622.569641 
	C684.608093,618.173828 687.128235,612.558167 686.464722,606.543701 
z"
          />
          <path
            fill="#060606"
            opacity="1.000000"
            stroke="none"
            d="
M685.829834,253.779327 
	C686.000793,253.076538 686.171753,252.373749 686.849609,251.260406 
	C687.469421,250.095474 687.582336,249.341110 687.695312,248.586731 
	C687.700134,248.217819 687.705017,247.848907 688.131348,246.977371 
	C688.611023,245.192581 688.669312,243.910431 688.727539,242.628265 
	C688.675781,241.472595 688.624023,240.316940 688.753540,238.500580 
	C688.574036,236.862961 688.213318,235.886017 687.852600,234.909073 
	C687.630005,234.496796 687.407349,234.084518 687.107666,233.026184 
	C686.480896,231.873856 685.931213,231.367615 685.381470,230.861389 
	C685.381470,230.861404 685.148193,230.875977 685.099731,230.411041 
	C681.845337,228.784073 678.639526,227.622040 675.433655,226.460022 
	C674.500366,226.391113 673.567139,226.322205 672.027466,225.831390 
	C667.953674,225.630600 664.486145,225.851715 661.018677,226.072815 
	C660.670837,226.189621 660.323059,226.306412 659.306396,226.216125 
	C657.148743,225.934525 655.659851,225.860031 654.171021,225.785522 
	C655.716797,224.795258 657.291748,224.438400 658.865845,224.077988 
	C663.608032,222.992157 668.349915,221.904953 673.091919,220.818298 
	C673.857666,220.676605 674.623413,220.534882 676.107300,220.689682 
	C682.836548,220.825317 688.847534,220.664413 694.858582,220.503525 
	C695.336426,220.474457 695.814270,220.445374 696.724182,220.911713 
	C700.421936,222.604553 703.687561,223.801987 706.953247,224.999420 
	C706.953247,224.999420 706.999390,224.983673 707.025208,225.341141 
	C707.729980,226.104477 708.408875,226.510361 709.087830,226.916229 
	C709.258911,226.963821 709.429932,227.011429 709.724487,227.588806 
	C710.753418,229.099304 711.658752,230.080048 712.564148,231.060791 
	C712.737549,231.432190 712.910950,231.803589 713.097656,232.871399 
	C713.728333,235.697678 714.345703,237.827560 714.963135,239.957428 
	C715.027832,241.052536 715.092590,242.147644 714.812927,243.792587 
	C714.509583,245.190689 714.550598,246.038956 714.591675,246.887207 
	C714.489258,247.656830 714.386841,248.426437 713.883972,249.690063 
	C713.363098,250.838196 713.242615,251.492294 713.122192,252.146393 
	C712.967224,252.868454 712.812317,253.590515 712.141541,254.739441 
	C710.482361,258.197083 709.338989,261.227875 708.195618,264.258636 
	C708.044861,264.648621 707.894043,265.038605 707.235352,265.763031 
	C706.182861,267.431610 705.638245,268.765747 705.093628,270.099884 
	C705.093628,270.099884 705.021973,270.593140 704.526855,270.821167 
	C702.108582,274.485779 700.185486,277.922333 698.262390,281.358887 
	C697.871643,282.072510 697.480957,282.786163 696.567017,283.752808 
	C695.725769,284.702484 695.407776,285.399170 695.089783,286.095856 
	C695.041138,286.267120 694.992432,286.438416 694.431396,286.796326 
	C693.626160,287.658844 693.333252,288.334839 693.040405,289.010834 
	C692.977173,289.182739 692.913940,289.354614 692.342346,289.766083 
	C691.256836,291.042969 690.679749,292.080292 690.102600,293.117615 
	C689.790283,293.602966 689.477966,294.088318 688.638306,294.799164 
	C687.772583,295.718475 687.434204,296.412292 687.095764,297.106110 
	C686.791809,297.609344 686.487854,298.112610 685.616943,298.788910 
	C684.707703,299.633453 684.365356,300.304932 684.023071,300.976379 
	C683.684387,301.500366 683.345764,302.024323 682.465454,302.747192 
	C681.602051,303.574707 681.280273,304.203339 680.958496,304.831970 
	C666.062256,323.656158 649.600342,341.099731 631.202759,356.413452 
	C600.295715,382.139771 568.652527,406.980988 537.389771,432.281769 
	C534.898560,434.297882 532.873718,434.244110 530.200989,432.854004 
	C500.975952,417.653839 471.844635,402.262360 442.370270,387.559570 
	C433.626373,383.197845 434.399139,373.523163 441.711639,369.435333 
	C465.669373,356.042542 489.235687,341.931671 515.228516,332.611237 
	C519.862976,330.949432 524.318420,330.213318 529.332275,331.552185 
	C536.528687,333.473969 543.764160,327.961548 546.177368,320.127716 
	C546.975769,317.535858 548.678284,314.512604 550.874329,313.170471 
	C574.077393,298.989777 598.213013,286.728088 624.427307,278.993317 
	C625.860901,278.570343 627.321472,278.223145 628.788513,277.939056 
	C629.223022,277.854950 629.722839,278.108215 630.734192,278.320587 
	C630.734192,287.723419 630.870972,297.161896 630.585449,306.587555 
	C630.543091,307.986481 628.783386,309.803131 627.356506,310.620544 
	C602.564697,324.823120 577.700745,338.899567 552.112976,352.984680 
	C545.933350,355.173401 540.682922,357.128937 534.367920,356.265411 
	C531.453857,355.866913 528.049438,359.054230 524.867310,360.615723 
	C524.867310,360.615723 524.820984,360.854553 524.355774,360.894318 
	C517.347290,368.269867 518.895386,379.268341 526.992188,382.969269 
	C527.171692,383.011414 527.351135,383.053589 527.808228,383.627319 
	C531.035706,384.488068 533.985535,384.817291 536.935364,385.146484 
	C537.328857,385.016907 537.722351,384.887329 538.770813,384.870972 
	C540.657776,384.128387 541.889832,383.272583 543.121826,382.416809 
	C543.712463,381.786194 544.303101,381.155579 545.440063,380.275574 
	C546.302185,379.332306 546.617981,378.638458 546.933838,377.944580 
	C547.082336,377.506714 547.230896,377.068848 547.895508,376.259003 
	C550.619568,373.693695 552.827576,371.500366 555.035522,369.307037 
	C555.035522,369.307037 555.366272,368.954224 555.904297,368.974670 
	C556.983521,368.489197 557.524780,367.983246 558.065979,367.477295 
	C558.187561,367.344849 558.309143,367.212372 559.025879,367.047791 
	C560.783264,366.135437 561.945557,365.255157 563.107849,364.374878 
	C564.555664,363.296143 566.003479,362.217438 568.137268,361.106079 
	C571.252319,359.337952 573.681335,357.602417 576.110352,355.866882 
	C577.213806,354.982330 578.317200,354.097778 580.045959,353.152710 
	C581.139954,352.574738 581.608582,352.057281 582.077271,351.539856 
	C582.203613,351.400116 582.330017,351.260406 583.024353,351.087830 
	C584.083923,350.522949 584.575623,349.990967 585.067261,349.458984 
	C585.167542,349.310120 585.267883,349.161255 585.986328,349.018524 
	C590.768250,345.887817 594.932007,342.750977 599.095703,339.614166 
	C599.212769,339.451294 599.329834,339.288452 600.039185,339.097534 
	C601.104126,338.502991 601.576721,337.936523 602.049316,337.370056 
	C602.521729,336.981415 602.994202,336.592773 604.029785,336.146912 
	C605.094971,335.628571 605.597107,335.167450 606.099243,334.706329 
	C606.213257,334.539429 606.327271,334.372498 607.016296,334.128876 
	C608.106201,333.537659 608.621094,333.023102 609.135986,332.508545 
	C609.599121,332.085175 610.062317,331.661804 611.124695,331.165039 
	C612.169189,330.536835 612.614502,329.982025 613.059753,329.427216 
	C613.185669,329.301086 613.311523,329.174927 614.042419,329.027527 
	C616.460938,327.528473 618.274475,326.050751 620.088013,324.572998 
	C620.188965,324.417419 620.289917,324.261841 620.973877,324.055908 
	C622.394043,323.166626 623.231140,322.327667 624.068298,321.488708 
	C624.212463,321.378632 624.356567,321.268524 625.053650,321.083618 
	C626.091797,320.483643 626.576904,319.958496 627.062012,319.433319 
	C627.527100,319.015747 627.992188,318.598175 629.051514,318.130951 
	C630.122070,317.549347 630.598389,317.017395 631.074707,316.485413 
	C632.231262,315.424744 633.387817,314.364075 635.143677,313.200439 
	C636.185974,312.561371 636.628967,312.025238 637.072021,311.489136 
	C638.259949,310.458160 639.447876,309.427185 641.234497,308.227753 
	C642.570435,307.152313 643.307739,306.245361 644.044983,305.338379 
	C645.536682,303.994843 647.028442,302.651276 649.152832,301.161072 
	C651.555420,299.092224 653.325195,297.169983 655.094971,295.247742 
	C655.094971,295.247742 655.082642,295.084320 655.463013,295.081604 
	C656.260925,294.470917 656.678467,293.862915 657.095947,293.254913 
	C657.095947,293.254913 657.073608,293.093262 657.486206,293.075012 
	C658.928345,291.732056 659.957764,290.407379 660.987244,289.082703 
	C661.687195,288.219147 662.387146,287.355591 663.620911,286.285217 
	C664.482605,285.520447 664.810425,284.962494 665.138184,284.404510 
	C665.138184,284.404510 665.128662,284.179565 665.569031,284.133392 
	C667.326843,282.389130 668.644226,280.691040 669.961609,278.992920 
	C670.052429,278.811981 670.143311,278.631012 670.779419,278.236633 
	C671.889954,277.053223 672.455261,276.083191 673.020630,275.113159 
	C673.348450,274.566040 673.676270,274.018860 674.550415,273.240479 
	C675.393127,272.352600 675.689514,271.695953 675.985840,271.039276 
	C676.062378,270.850708 676.138916,270.662109 676.765869,270.235596 
	C678.214722,268.362549 679.113159,266.727448 680.011658,265.092346 
	C681.491211,262.294312 682.970764,259.496216 684.937500,256.276306 
	C685.559753,255.162766 685.694763,254.471054 685.829834,253.779327 
z"
          />
          <path
            fill="#1C86CA"
            opacity="1.000000"
            stroke="none"
            d="
M436.902985,443.602844 
	C437.378357,443.585541 437.853760,443.568237 438.937744,443.529053 
	C440.346069,443.285950 441.145813,443.064819 441.945526,442.843658 
	C442.412933,442.806213 442.880371,442.768768 444.031921,442.655945 
	C445.724945,442.718689 446.733795,442.856781 448.799896,443.139587 
	C444.768250,445.383636 441.686188,447.099152 438.604156,448.814636 
	C438.604156,448.814667 438.258026,448.766449 437.763977,448.848877 
	C435.990814,449.534760 434.711700,450.138184 433.432556,450.741638 
	C423.580078,451.975494 413.688232,454.443909 403.885132,454.131012 
	C391.604156,453.739014 380.650818,449.033173 375.995789,436.017670 
	C373.395691,428.747742 373.829773,421.290070 375.516083,413.835754 
	C379.384888,396.733948 388.791595,382.720184 400.182098,369.895020 
	C418.665802,349.083282 440.239807,331.846649 463.695892,317.072723 
	C482.685852,305.111877 502.187073,293.955811 521.606628,282.693024 
	C523.941711,281.338776 527.233215,280.938293 529.998596,281.154663 
	C537.618286,281.750854 544.411011,277.505585 545.966064,270.568085 
	C547.503540,263.708984 543.908203,256.500702 537.769470,254.134613 
	C530.457703,251.316422 523.753479,254.374451 519.630737,261.415466 
	C517.463989,265.115936 514.367249,268.569092 510.968842,271.202698 
	C489.547913,287.802887 467.904999,304.116333 446.387390,320.592377 
	C442.833130,323.313873 439.546082,326.383148 436.099670,329.248596 
	C435.781708,329.512939 435.202148,329.462677 434.371826,329.636322 
	C434.191925,328.238525 433.890930,326.987732 433.891144,325.737000 
	C433.894073,308.408875 434.079102,291.079132 433.883026,273.753601 
	C433.827271,268.823730 435.621674,265.758667 439.765686,263.247437 
	C459.256287,251.436203 478.643524,239.453827 498.035187,227.480026 
	C508.652802,220.923935 519.259155,214.346222 529.755127,207.598587 
	C532.796509,205.643326 535.260742,205.517578 538.404602,207.458405 
	C566.999207,225.111160 595.717773,242.563828 624.251709,260.313507 
	C626.937866,261.984467 629.160461,265.018402 630.577820,267.918274 
	C631.739563,270.295258 629.931274,272.299377 627.066650,272.701843 
	C597.913330,276.797729 570.954895,287.745483 544.087891,299.068451 
	C540.363892,300.637939 536.077332,301.349030 532.011597,301.520813 
	C525.742432,301.785706 520.731262,304.035370 518.371643,309.775330 
	C516.062439,315.392731 511.539398,317.982056 506.834656,320.872742 
	C486.159698,333.575806 465.164001,345.824524 445.139038,359.489960 
	C434.675201,366.630707 425.979675,376.362732 415.974426,385.256226 
	C414.890686,386.674500 414.318024,387.760925 413.745361,388.847351 
	C413.745331,388.847351 413.867828,388.866028 413.509369,388.914673 
	C412.365112,390.272491 411.579315,391.581696 410.793518,392.890900 
	C410.793518,392.890900 410.892853,392.894836 410.572388,392.928375 
	C409.930511,393.649384 409.609100,394.336853 409.287689,395.024323 
	C409.287689,395.024323 408.975861,395.364044 408.623871,395.710724 
	C407.425323,397.653259 406.578796,399.249084 405.732239,400.844940 
	C405.732239,400.844940 405.839600,400.864410 405.494293,400.936157 
	C404.682587,402.291901 404.216187,403.575867 403.749756,404.859833 
	C403.749756,404.859833 403.909149,404.972595 403.567993,405.064270 
	C403.059662,405.771851 402.892456,406.387817 402.725250,407.003754 
	C402.725250,407.003754 402.616821,407.168030 402.344421,407.460693 
	C401.303040,410.185455 400.534027,412.617554 399.765015,415.049652 
	C399.587219,415.486725 399.409454,415.923798 398.973145,417.003418 
	C399.065155,421.277771 399.415710,424.909607 399.766235,428.541412 
	C399.766235,428.541412 399.640747,428.788208 399.714539,429.266052 
	C400.782806,431.246735 401.777283,432.749603 402.771759,434.252472 
	C402.771759,434.252472 402.872437,434.170898 402.857544,434.449890 
	C403.155151,434.911835 403.467621,435.094818 403.780060,435.277832 
	C403.780060,435.277832 403.855865,435.140320 403.860840,435.448425 
	C404.181458,435.921417 404.497131,436.086273 404.812836,436.251129 
	C404.812836,436.251129 404.864502,436.135284 404.872162,436.432129 
	C405.191833,436.901306 405.503845,437.073639 405.815857,437.245972 
	C405.815857,437.245972 405.875702,437.125641 405.889404,437.427612 
	C406.228088,437.883820 406.553131,438.038116 406.878143,438.192413 
	C406.878143,438.192413 406.895660,438.063568 406.970703,438.434021 
	C408.699951,439.563263 410.354156,440.322083 412.008362,441.080872 
	C412.008362,441.080872 412.218872,441.281738 412.515198,441.529205 
	C413.555878,441.992523 414.300262,442.208405 415.044647,442.424255 
	C415.468781,442.597961 415.892914,442.771667 416.837463,443.192108 
	C417.923279,443.427734 418.488708,443.416656 419.054108,443.405548 
	C419.494171,443.561951 419.934235,443.718353 421.022400,444.096130 
	C426.747986,444.079285 431.825500,443.841064 436.902985,443.602844 
z"
          />
          <path
            fill="#223146"
            opacity="1.000000"
            stroke="none"
            d="
M609.964050,531.000244 
	C609.994385,538.823547 610.060913,546.147095 610.041443,553.470398 
	C610.025757,559.381531 607.807922,561.920044 602.092957,562.021667 
	C592.275513,562.196228 582.452026,562.022278 572.633972,562.175964 
	C569.355347,562.227295 568.263611,560.870911 568.276855,557.752686 
	C568.342468,542.274780 568.329834,526.796265 568.265930,511.318329 
	C568.253540,508.314880 569.485107,507.283508 572.470154,507.331055 
	C582.121765,507.484863 591.778442,507.316345 601.429932,507.473724 
	C607.662781,507.575348 609.821960,509.852692 609.938660,516.020203 
	C610.029907,520.845398 609.960938,525.673584 609.964050,531.000244 
M597.138489,546.085754 
	C597.145203,540.932373 597.171387,535.778931 597.154663,530.625610 
	C597.116455,518.862061 597.113037,518.941101 585.188354,519.715027 
	C582.199097,519.908997 581.114197,521.043945 581.178894,523.999878 
	C581.309875,529.981384 581.173706,535.968445 581.176331,541.953186 
	C581.179810,549.901123 581.195496,550.043335 589.039490,549.829895 
	C591.869934,549.752991 595.658997,551.507080 597.138489,546.085754 
z"
          />
          <path
            fill="#202E45"
            opacity="1.000000"
            stroke="none"
            d="
M517.439697,552.027771 
	C517.372742,553.662720 517.203552,554.848572 517.365479,555.987366 
	C518.111267,561.231750 515.578369,562.296448 510.776581,562.359131 
	C505.728210,562.425049 504.240295,560.811951 504.348175,555.848938 
	C504.666138,541.218872 504.518066,526.578735 504.585846,511.942780 
	C504.591827,510.646271 504.841217,509.350861 505.025574,507.598114 
	C515.474609,507.598114 525.733276,507.358032 535.970703,507.720856 
	C539.853455,507.858521 542.256775,510.683502 542.105469,514.863037 
	C541.884216,520.972717 541.426025,527.074524 541.266541,533.184937 
	C541.238708,534.251221 542.168579,535.350525 542.683899,536.421204 
	C543.832031,538.806763 545.707336,541.099060 546.004333,543.582642 
	C546.573669,548.343140 546.180481,553.212341 546.324463,558.032410 
	C546.410156,560.899841 545.463928,562.473206 542.334656,562.237915 
	C540.681152,562.113586 539.008545,562.180176 537.347168,562.237122 
	C534.519775,562.333801 532.821655,561.345276 533.229980,558.182495 
	C533.251099,558.018921 533.235779,557.850098 533.231812,557.683838 
	C532.987488,547.520264 530.718872,545.691406 520.432739,547.940918 
	C519.245056,548.200623 518.461060,550.306885 517.439697,552.027771 
M524.456482,519.691650 
	C517.332214,519.784546 517.332520,519.784546 517.296265,526.672974 
	C517.291931,527.499573 517.382935,528.341614 517.258484,529.150208 
	C516.482544,534.193237 518.582581,535.768188 523.617004,535.609253 
	C527.808838,535.476929 529.870972,534.560242 529.276917,530.034180 
	C529.020935,528.084167 529.107910,526.061462 529.270447,524.090759 
	C529.510986,521.174561 528.305115,519.727661 524.456482,519.691650 
z"
          />
          <path
            fill="#223146"
            opacity="1.000000"
            stroke="none"
            d="
M356.179565,535.868774 
	C361.526276,543.017822 359.958588,550.719177 358.396454,558.084473 
	C358.021790,559.851074 354.135803,561.931152 351.782715,562.036499 
	C341.648865,562.490295 331.482758,562.158508 321.331909,562.326294 
	C316.084015,562.412964 317.194672,558.823364 317.131622,555.802063 
	C317.067688,552.740173 316.704437,549.690674 321.446564,549.820068 
	C328.264496,550.006104 335.099274,549.944092 341.911957,549.646851 
	C343.276672,549.587280 345.755890,547.842957 345.664032,547.146973 
	C345.455597,545.567688 344.292633,543.379822 342.941589,542.813293 
	C337.129089,540.375610 331.091980,538.479248 325.168396,536.299377 
	C319.303497,534.141113 317.367279,531.391785 317.179871,525.122986 
	C317.105286,522.627869 317.114044,520.129089 317.138672,517.632507 
	C317.213318,510.071106 319.374420,507.660004 326.732697,507.461243 
	C334.884705,507.241028 343.052368,507.473022 351.195923,507.114960 
	C355.691772,506.917236 356.157410,509.353210 355.856018,512.700500 
	C355.570587,515.869812 357.197052,520.187866 351.211182,519.906372 
	C345.894989,519.656372 340.548004,519.627747 335.239044,519.930359 
	C333.693420,520.018433 332.231720,521.579346 330.731567,522.465088 
	C331.845276,524.047791 332.615875,526.420105 334.131195,527.078491 
	C341.279083,530.184387 348.630859,532.820862 356.179565,535.868774 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M274.996277,508.243378 
	C279.326813,508.267700 283.163605,508.182037 286.990479,508.339264 
	C292.836456,508.579468 295.379944,511.221466 295.633545,517.038574 
	C296.372925,533.998230 295.860992,534.714783 279.785278,540.095154 
	C276.315094,541.256592 272.746307,542.303345 269.548584,544.012207 
	C268.233398,544.714966 267.410004,546.970520 267.146637,548.643188 
	C267.062012,549.180664 269.465881,550.715576 270.769073,550.763306 
	C277.091858,550.995056 283.442749,551.147034 289.753448,550.790894 
	C294.284943,550.535217 296.323975,551.903992 295.705811,556.593018 
	C295.448700,558.543274 295.493011,560.533264 295.388794,562.748901 
	C283.164673,562.748901 271.229279,562.946228 259.314697,562.536987 
	C257.519745,562.475281 255.700821,559.690063 254.144073,557.941162 
	C253.588104,557.316528 253.717484,556.035217 253.632187,555.045227 
	C252.268707,539.219116 253.289444,537.594299 268.194794,532.003784 
	C271.465454,530.777039 274.745087,529.562439 278.069641,528.494995 
	C280.700531,527.650330 283.084442,526.279419 281.948669,523.325684 
	C281.455933,522.044128 278.795441,521.020996 277.051117,520.904358 
	C271.907043,520.560486 266.728760,520.703125 261.563873,520.702576 
	C255.757080,520.701965 257.505554,516.304871 257.100311,513.136902 
	C256.670746,509.778595 257.995758,508.187195 261.503357,508.277252 
	C265.831818,508.388428 270.166260,508.264526 274.996277,508.243378 
z"
          />
          <path
            fill="#212F45"
            opacity="1.000000"
            stroke="none"
            d="
M784.494263,561.437927 
	C784.102112,558.475098 783.701050,555.805847 783.906555,553.184021 
	C784.192749,549.532349 782.517456,548.411377 779.241760,548.723389 
	C779.076843,548.739136 778.908752,548.724060 778.742188,548.720642 
	C768.872314,548.519592 768.748230,548.514343 768.336670,558.304871 
	C768.205566,561.424805 766.969238,562.323120 764.086121,562.283447 
	C753.289124,562.134827 755.905701,563.363037 754.620667,553.539185 
	C752.373291,536.357544 761.603943,523.252686 768.543884,509.267609 
	C770.271973,505.785187 782.165527,506.411774 784.003601,509.964630 
	C788.202576,518.081299 793.472229,525.980347 795.778748,534.641113 
	C797.899658,542.604980 796.785828,551.448914 796.858154,559.907166 
	C796.864441,560.643921 795.121155,561.980896 794.137573,562.032471 
	C791.023804,562.196045 787.885010,561.882019 784.494263,561.437927 
M775.553894,536.194092 
	C777.897888,536.194092 780.241882,536.194092 783.991455,536.194092 
	C781.559814,531.166504 779.915894,527.461670 777.930054,523.950134 
	C777.582458,523.335571 774.997009,523.079102 774.800903,523.425293 
	C772.616577,527.281189 770.698975,531.288147 768.212158,536.245605 
	C771.421936,536.245605 773.037170,536.245605 775.553894,536.194092 
z"
          />
          <path
            fill="#223046"
            opacity="1.000000"
            stroke="none"
            d="
M642.407104,515.235046 
	C646.605957,506.030975 648.208252,507.118988 657.221436,507.501373 
	C658.622192,507.560822 660.476929,509.201660 661.213196,510.592285 
	C665.177246,518.079163 669.529907,525.474426 672.383362,533.393311 
	C674.166016,538.340210 673.574707,544.152771 673.972839,549.582458 
	C674.106445,551.405029 674.015930,553.244812 674.010376,555.076660 
	C673.988342,562.319214 673.985840,562.319214 666.988098,562.272705 
	C660.812622,562.231689 660.812561,562.231689 660.805420,555.398315 
	C660.798462,548.715210 660.798523,548.713623 654.319946,548.643250 
	C653.154297,548.630554 651.975159,548.750427 650.825073,548.615173 
	C646.538574,548.111084 644.576599,549.834595 645.063477,554.244080 
	C645.226685,555.722778 645.511536,557.459534 644.919067,558.679138 
	C644.230103,560.097290 642.742004,561.950867 641.422363,562.106873 
	C631.909058,563.231934 632.668823,563.017395 631.726135,553.659485 
	C630.287842,539.382751 635.190918,527.277710 642.407104,515.235046 
M658.848999,531.742432 
	C657.681396,529.371887 656.783936,526.797241 655.219299,524.726746 
	C654.550293,523.841370 651.445618,523.405579 651.225464,523.788269 
	C649.142151,527.410034 647.442078,531.252197 645.058228,536.227661 
	C650.251892,536.227661 653.997620,536.388428 657.699890,536.059692 
	C658.275574,536.008606 658.652710,533.722168 658.848999,531.742432 
z"
          />
          <path
            fill="#223046"
            opacity="1.000000"
            stroke="none"
            d="
M482.382385,541.257202 
	C482.383148,547.055969 482.327087,552.388611 482.385498,557.720032 
	C482.418762,560.756592 481.333252,562.159058 478.016327,562.273254 
	C469.479858,562.567261 469.292999,562.710449 469.421387,554.159546 
	C469.482941,550.060303 468.182159,548.225586 464.007202,548.755737 
	C463.023132,548.880737 462.009644,548.772949 461.009674,548.773926 
	C453.946686,548.780884 453.687927,548.786621 453.837646,555.684021 
	C453.944122,560.591919 452.321350,562.873230 447.230103,562.278381 
	C445.293884,562.052124 443.309113,562.241577 440.497345,562.241577 
	C441.650330,550.682617 438.141998,539.325012 444.139954,528.644531 
	C447.315308,522.990173 450.201813,517.147156 452.806976,511.208710 
	C454.429932,507.509125 457.133759,507.029999 460.496735,507.260590 
	C464.132690,507.509949 468.115417,506.108856 470.272980,511.026154 
	C473.478058,518.330811 477.399078,525.319641 480.664032,532.600525 
	C481.778656,535.086182 481.834106,538.046875 482.382385,541.257202 
M464.661621,525.815430 
	C461.634552,521.517029 460.752106,521.513550 458.407715,525.849976 
	C457.386688,527.738525 456.341858,529.623901 455.479584,531.586243 
	C454.236176,534.415894 454.472321,536.207642 458.337677,536.407959 
	C469.440857,536.983398 469.765381,536.604309 464.661621,525.815430 
z"
          />
          <path
            fill="#223046"
            opacity="1.000000"
            stroke="none"
            d="
M709.933350,530.020874 
	C709.928284,529.189148 709.926880,528.856079 709.922119,528.523071 
	C709.784241,518.929260 711.268555,519.529114 701.026917,519.956543 
	C694.935547,520.210876 695.952576,516.644714 695.716553,512.978760 
	C695.449219,508.825623 696.506287,506.994537 701.180542,507.146423 
	C711.493225,507.481537 721.832275,507.458344 732.145691,507.123718 
	C737.121399,506.962219 737.998047,509.206207 737.879211,513.432129 
	C737.769897,517.319641 737.668396,520.096558 732.361877,519.903931 
	C723.163269,519.569885 723.338989,517.746460 723.433960,528.926758 
	C723.515991,538.583862 723.397339,548.243469 723.554688,557.898865 
	C723.607727,561.154480 722.414917,562.299133 719.178223,562.260620 
	C708.333252,562.131287 710.001282,563.328674 709.901978,553.498474 
	C709.824585,545.839783 709.917908,538.179321 709.933350,530.020874 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M397.004639,507.237610 
	C404.484314,507.254059 411.466797,507.360199 418.445679,507.246765 
	C421.637512,507.194885 423.254608,507.919678 423.256012,511.655853 
	C423.259064,519.765076 423.453644,520.039368 415.213165,519.678650 
	C410.269196,519.462219 408.561035,520.768921 408.787720,526.012512 
	C409.239655,536.466064 408.711060,546.958923 408.993011,557.424561 
	C409.104889,561.575684 407.534515,562.815002 403.793030,562.318909 
	C403.629578,562.297241 403.460907,562.315674 403.294647,562.314636 
	C395.622253,562.267700 395.547668,562.268188 395.494934,554.788879 
	C395.425751,544.981384 395.301514,535.167542 395.581329,525.367310 
	C395.704041,521.069580 394.481628,519.044006 390.003937,519.746338 
	C389.517090,519.822693 389.008087,519.759033 388.509338,519.757812 
	C381.337463,519.740295 378.871643,516.439087 381.279846,509.570007 
	C381.655182,508.499390 383.697418,507.491119 385.043854,507.382385 
	C388.843658,507.075500 392.682465,507.251709 397.004639,507.237610 
z"
          />
          <path
            fill="#3F8DB9"
            opacity="1.000000"
            stroke="none"
            d="
M577.534607,594.731934 
	C577.864624,593.551636 578.122375,592.140320 578.440369,592.126648 
	C583.618530,591.903320 588.953369,591.065308 593.944397,592.004761 
	C598.466675,592.856018 601.124573,596.950195 600.859619,601.790771 
	C600.712158,604.483215 600.062073,607.667664 598.437012,609.640808 
	C595.854431,612.776489 596.333984,615.221741 598.218140,618.140259 
	C598.931274,619.244995 599.690186,620.490417 599.835754,621.740723 
	C599.966003,622.859436 599.591125,624.744507 598.877380,625.073730 
	C597.997803,625.479492 596.037720,625.017639 595.423462,624.238220 
	C593.793640,622.170105 592.949768,619.441162 591.190369,617.530273 
	C589.836914,616.060364 587.639954,615.083130 585.656250,614.676941 
	C585.160095,614.575317 584.002991,617.498718 583.233032,619.072571 
	C583.029541,619.488525 583.290222,620.138977 583.074402,620.540283 
	C582.171814,622.219482 581.169006,623.844788 580.202881,625.489868 
	C579.241455,623.703247 577.504700,621.939392 577.451416,620.126038 
	C577.206787,611.808655 577.433105,603.477417 577.534607,594.731934 
M591.490417,596.565125 
	C582.834351,595.283081 582.473450,595.553284 582.884583,604.295532 
	C582.953674,605.764587 584.026367,608.491638 584.273621,608.450745 
	C587.825317,607.863220 592.318787,607.937256 594.563599,605.763672 
	C597.320374,603.094421 596.431763,598.955933 591.490417,596.565125 
z"
          />
          <path
            fill="#438EBB"
            opacity="1.000000"
            stroke="none"
            d="
M539.862671,605.634460 
	C542.496704,605.738098 544.740662,605.493530 546.777161,606.032776 
	C548.056824,606.371704 549.025085,607.886475 550.133057,608.873657 
	C548.900635,609.728516 547.769043,611.018860 546.411499,611.333191 
	C544.513611,611.772522 542.438843,611.609009 540.454712,611.477600 
	C537.359924,611.272705 536.401245,612.720032 536.439514,615.642212 
	C536.476807,618.489075 536.822571,620.545837 540.436890,620.356567 
	C543.750305,620.183105 547.103027,620.161743 550.394653,620.499573 
	C551.509521,620.614014 552.490662,622.030640 553.532959,622.852173 
	C552.542358,623.946716 551.582397,625.949585 550.556091,625.984131 
	C545.094116,626.168091 539.588501,626.112000 534.163025,625.531372 
	C532.905151,625.396667 530.966003,622.910828 530.933167,621.470581 
	C530.729004,612.511597 530.850891,603.536987 531.227722,594.582825 
	C531.278625,593.374939 533.285645,591.363403 534.528625,591.247803 
	C539.473267,590.787537 544.485107,590.723755 549.446533,590.990051 
	C550.760925,591.060547 551.983887,592.835083 553.248779,593.827209 
	C552.031982,594.672668 550.889587,596.076050 549.583191,596.250244 
	C546.640137,596.642944 543.581421,596.170898 540.639282,596.567017 
	C539.175415,596.764038 536.769958,598.012573 536.697449,598.935364 
	C536.507935,601.345703 534.868469,604.921570 539.862671,605.634460 
z"
          />
          <path
            fill="#3F8DB9"
            opacity="1.000000"
            stroke="none"
            d="
M783.251953,596.451294 
	C780.004639,596.508789 777.172302,596.641418 774.343750,596.585632 
	C771.387207,596.527405 769.304321,596.775574 769.298035,600.779358 
	C769.291443,604.937439 771.025024,606.048157 774.705017,605.641663 
	C776.020142,605.496338 777.500793,605.264771 778.663879,605.707886 
	C780.319214,606.338379 781.751343,607.554810 783.278809,608.520996 
	C781.797485,609.501892 780.431824,610.863403 778.802856,611.358582 
	C777.115173,611.871582 775.162842,611.680908 773.343018,611.554932 
	C770.167297,611.335083 769.331543,612.896606 769.442139,615.786316 
	C769.543030,618.423279 769.898499,620.390808 773.225952,620.306335 
	C776.552063,620.221863 779.917419,620.154663 783.198242,620.588928 
	C784.459167,620.755859 785.534058,622.328125 786.693665,623.260132 
	C785.540894,624.251892 784.415344,626.056030 783.230652,626.095642 
	C777.917786,626.273682 772.561279,626.196716 767.284668,625.622498 
	C766.058350,625.489014 764.183350,623.072815 764.139526,621.659363 
	C763.860840,612.681641 763.859924,603.684998 764.185059,594.709717 
	C764.234131,593.354858 766.380066,591.055908 767.700012,590.947693 
	C772.824951,590.527283 778.015686,590.670227 783.163330,590.947998 
	C784.338806,591.011475 785.439941,592.450134 786.575317,593.255859 
	C785.606445,594.318420 784.637573,595.380981 783.251953,596.451294 
z"
          />
          <path
            fill="#3F8DB9"
            opacity="1.000000"
            stroke="none"
            d="
M426.922363,616.047363 
	C428.441223,617.833618 429.990143,619.203369 430.941284,620.906799 
	C431.521423,621.945740 431.181244,623.498535 431.254456,624.820557 
	C429.887695,624.668884 428.057007,625.024231 427.237549,624.274414 
	C424.302917,621.589294 421.817566,618.418396 418.941284,615.661804 
	C417.626373,614.401611 415.796509,613.678833 414.200226,612.712280 
	C413.429810,614.608337 412.498291,616.458984 411.947357,618.416748 
	C411.597687,619.659363 412.119812,621.171448 411.691132,622.360840 
	C411.258698,623.560608 410.134552,624.511047 409.313446,625.570740 
	C408.374725,624.457886 406.667572,623.374878 406.623108,622.227356 
	C406.352875,615.248840 406.457916,608.255676 406.444885,601.267395 
	C406.440552,598.937500 406.192017,596.563354 406.570770,594.295471 
	C406.776550,593.063660 408.065765,592.012756 408.866272,590.880188 
	C409.833771,592.035217 411.451843,593.095459 411.636932,594.364563 
	C412.056061,597.238647 411.768768,600.215698 411.768768,603.150818 
	C412.245056,603.416077 412.721375,603.681335 413.197662,603.946594 
	C414.978424,602.237915 416.802338,600.571472 418.526947,598.807983 
	C420.037354,597.263428 421.216644,595.292053 422.947632,594.095886 
	C424.593719,592.958374 426.764862,592.580627 428.705200,591.868835 
	C428.241821,593.759216 427.820709,595.661743 427.283325,597.530823 
	C427.160126,597.959290 426.616241,598.255737 426.300751,598.641418 
	C418.224304,608.513855 417.088928,604.792908 426.922363,616.047363 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M242.001434,605.089355 
	C247.099030,607.055786 251.005463,610.327209 249.947098,615.509949 
	C249.256165,618.893433 246.329254,622.565796 243.363098,624.562439 
	C239.037582,627.474182 233.949020,626.354553 229.905060,623.095154 
	C228.696243,622.120850 228.576462,619.795410 227.957733,618.088989 
	C229.660477,618.186829 231.392197,618.123535 233.058548,618.423462 
	C235.105103,618.791870 237.274307,620.218628 239.064285,619.798401 
	C240.971207,619.350647 243.596313,617.466431 243.868530,615.863098 
	C244.121811,614.371216 242.006790,611.993042 240.361038,610.788330 
	C238.406204,609.357239 235.838516,608.763733 233.537125,607.805481 
	C229.456345,606.106384 227.689850,603.056458 228.299271,598.684387 
	C228.911270,594.293762 231.619751,591.918274 235.862991,591.304077 
	C240.172501,590.680420 244.323517,591.032166 246.889038,595.174683 
	C247.412720,596.020203 247.183487,597.790894 246.607056,598.690186 
	C246.249893,599.247498 244.531128,599.208313 243.520813,598.989014 
	C242.606705,598.790649 241.786072,597.481567 240.991516,597.542297 
	C238.780579,597.711365 235.525833,597.612671 234.637756,598.933716 
	C232.743423,601.751343 235.765472,602.689575 237.923904,603.538330 
	C239.161896,604.025146 240.411987,604.481262 242.001434,605.089355 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M831.257935,621.060120 
	C825.147583,626.826294 818.653748,627.762573 813.140442,623.378113 
	C811.752136,622.274048 811.617981,619.592896 810.907471,617.636475 
	C812.677063,617.861511 814.448730,618.071411 816.215698,618.314941 
	C818.843567,618.677307 821.526550,619.540710 824.068359,619.229431 
	C825.263184,619.083069 826.940308,616.734619 827.013184,615.313049 
	C827.084595,613.921997 825.720947,611.872803 824.408691,611.117432 
	C821.709656,609.563477 818.597046,608.744141 815.705505,607.504089 
	C812.453552,606.109436 810.319641,603.470947 811.251221,600.058716 
	C812.005798,597.294922 813.672546,594.227783 815.883789,592.535095 
	C819.823730,589.519287 826.226074,590.551697 828.991516,594.104797 
	C829.835815,595.189514 829.722717,597.019470 830.048035,598.508179 
	C828.680115,598.512817 827.271729,598.720642 825.956787,598.458984 
	C824.865967,598.241882 823.811096,596.930908 822.871033,597.059692 
	C820.930176,597.325439 819.076538,598.228027 817.187012,598.868591 
	C818.339783,600.356506 819.264526,602.143250 820.710632,603.246643 
	C822.106812,604.311890 824.087280,604.574951 825.730469,605.359253 
	C832.924988,608.793091 834.545837,613.200806 831.257935,621.060120 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M485.545654,600.747803 
	C486.792145,591.884277 496.231476,587.755066 502.561066,593.117126 
	C503.777679,594.147705 503.890717,596.481018 504.512878,598.213379 
	C502.917633,598.205444 501.293976,598.377991 499.736115,598.132629 
	C498.482483,597.935242 497.206665,596.683228 496.123230,596.884033 
	C494.538879,597.177795 493.117859,598.352722 491.627197,599.152100 
	C492.594269,600.497559 493.287170,602.289734 494.589447,603.088989 
	C496.820007,604.457825 499.486542,605.091919 501.870575,606.240784 
	C505.446625,607.964111 507.392639,610.798767 507.476471,614.902710 
	C507.565582,619.266724 505.313599,622.072327 501.758789,624.091492 
	C497.567444,626.472168 490.369843,626.089050 487.220490,622.907471 
	C486.091034,621.766479 485.984314,619.613159 485.410767,617.921875 
	C487.050262,618.061707 488.711700,618.079712 490.324036,618.370239 
	C492.666351,618.792358 495.083923,620.083801 497.258850,619.725647 
	C498.891754,619.456787 501.180756,617.292969 501.362762,615.757629 
	C501.542358,614.242676 499.790039,611.937988 498.260254,610.909485 
	C495.825806,609.272766 492.582031,608.806458 490.228729,607.092529 
	C488.266418,605.663330 487.091003,603.153687 485.545654,600.747803 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M360.882935,622.162903 
	C353.912415,616.083130 352.185608,607.583923 356.108063,599.880920 
	C359.406891,593.402649 367.842804,589.574707 375.174957,591.284119 
	C376.285980,591.543213 377.616821,591.792175 378.342682,592.536621 
	C379.269257,593.486938 379.684326,594.936096 380.319855,596.170227 
	C379.031433,596.584045 377.613129,597.569458 376.477386,597.311340 
	C371.877869,596.266296 367.628815,596.058350 363.861206,599.589539 
	C359.197113,603.960876 358.265656,609.795105 361.594513,614.858215 
	C364.850281,619.810181 370.992310,621.622559 376.539551,619.100952 
	C378.643829,618.144470 381.122406,616.103394 382.183136,619.422241 
	C382.564209,620.614441 380.075928,623.719604 378.293030,624.425110 
	C372.396393,626.758667 366.547852,625.875488 360.882935,622.162903 
z"
          />
          <path
            fill="#438EBB"
            opacity="1.000000"
            stroke="none"
            d="
M712.769897,601.861328 
	C717.815430,592.689758 726.071167,588.656128 733.889771,591.675598 
	C735.659729,592.359070 736.819092,594.623657 738.259521,596.160400 
	C736.360046,596.506836 734.349487,597.438293 732.579712,597.102112 
	C723.064453,595.294739 715.625854,601.688721 717.295654,610.507629 
	C718.649414,617.657532 725.930725,621.942200 732.830383,619.627991 
	C733.772766,619.311890 734.670288,618.567444 735.594116,618.557922 
	C737.043762,618.542969 738.498230,618.984802 739.950623,619.233154 
	C739.381287,620.606323 739.205139,622.515686 738.180054,623.267334 
	C730.395386,628.975769 715.975525,624.615234 713.171509,615.317261 
	C711.951111,611.270508 712.769958,606.608765 712.769897,601.861328 
z"
          />
          <path
            fill="#438EBB"
            opacity="1.000000"
            stroke="none"
            d="
M640.403076,612.575928 
	C643.026794,606.403259 645.232178,600.481384 647.863525,594.755371 
	C648.532898,593.298767 650.555420,592.463928 651.956238,591.343445 
	C652.327454,593.081177 653.464661,595.102417 652.943787,596.510010 
	C649.891785,604.756592 646.566467,612.909607 643.044189,620.967896 
	C642.363464,622.525391 640.539978,624.196289 638.976807,624.517883 
	C638.084961,624.701416 636.197693,622.463867 635.541565,620.972168 
	C632.065735,613.069092 628.692200,605.111816 625.649902,597.035217 
	C625.054504,595.454407 626.075317,593.264709 626.350708,591.355896 
	C627.832214,592.586121 629.918152,593.523315 630.682983,595.101013 
	C633.066650,600.018066 634.848389,605.223755 637.105530,610.207825 
	C637.614990,611.332825 639.104553,612.014038 640.403076,612.575928 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M278.439392,593.045166 
	C278.677490,600.243469 278.739563,607.069214 278.823425,613.894714 
	C278.897522,619.923340 279.261108,620.259155 285.471283,620.342590 
	C287.968231,620.376160 290.510406,620.181030 292.941650,620.606506 
	C294.114655,620.811829 295.078339,622.213135 296.136841,623.072876 
	C295.053497,624.121765 294.022552,626.004272 292.877869,626.076233 
	C287.738007,626.399109 282.525421,626.563416 277.429962,625.984741 
	C275.897766,625.810669 273.547028,623.103577 273.471344,621.468811 
	C273.063538,612.660889 273.131073,603.822815 273.299072,595.000183 
	C273.365021,591.537842 274.922668,589.829895 278.439392,593.045166 
z"
          />
          <path
            fill="#3F8DB9"
            opacity="1.000000"
            stroke="none"
            d="
M323.485443,616.636292 
	C323.515686,611.530212 323.774139,606.872253 323.465515,602.252197 
	C323.315369,600.004578 322.354523,597.700989 321.311737,595.651184 
	C320.031586,593.134644 320.021790,591.530640 323.213531,591.133606 
	C325.020172,590.908936 326.844666,590.727966 328.662476,590.714661 
	C331.884430,590.691101 332.920197,592.738831 331.747192,595.612732 
	C330.631714,598.345703 329.725067,601.286316 329.438477,604.205444 
	C329.051514,608.146667 329.208099,612.161865 329.416504,616.130371 
	C329.496643,617.656677 330.379456,619.135559 330.860382,620.647583 
	C331.277771,621.959656 332.338531,623.726379 331.852936,624.495239 
	C331.277893,625.405701 329.375610,625.615540 328.001221,625.843811 
	C326.709442,626.058472 325.313721,626.108337 324.041870,625.848328 
	C322.847870,625.604187 320.993744,625.051697 320.802002,624.289734 
	C320.528717,623.203796 321.471252,621.788147 321.963013,620.540405 
	C322.422180,619.375305 322.970917,618.245422 323.485443,616.636292 
z"
          />
          <path
            fill="#3F8DB9"
            opacity="1.000000"
            stroke="none"
            d="
M686.462280,607.030701 
	C687.128235,612.558167 684.608093,618.173828 689.226318,622.569641 
	C689.528625,622.857361 688.563416,625.341370 688.188232,625.341248 
	C684.808960,625.340332 681.429749,625.012268 678.050537,624.780212 
	C678.137512,623.562378 678.017029,622.283447 678.353882,621.139160 
	C679.088379,618.644531 680.544006,616.270996 680.815125,613.752258 
	C681.239807,609.807434 681.176819,605.761536 680.827209,601.801941 
	C680.643982,599.726379 679.710144,597.556213 678.584961,595.761169 
	C676.738464,592.815613 677.558960,591.366516 680.717712,591.032532 
	C682.682007,590.824768 684.864136,590.627991 686.625122,591.288391 
	C687.740845,591.706787 689.112122,594.696228 688.924561,594.857910 
	C685.062500,598.188538 686.862488,602.592957 686.462280,607.030701 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M672.683167,220.714935 
	C668.349915,221.904953 663.608032,222.992157 658.865845,224.077988 
	C657.291748,224.438400 655.716797,224.795258 654.171021,225.785522 
	C655.659851,225.860031 657.148743,225.934525 659.032959,226.159103 
	C652.539368,227.681259 645.650391,229.053329 638.371704,230.163300 
	C637.896240,229.682053 637.810425,229.462906 637.724609,229.243759 
	C649.241211,226.366379 660.757812,223.488998 672.683167,220.714935 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M439.009857,448.875610 
	C441.686188,447.099152 444.768250,445.383636 448.799896,443.139587 
	C446.733795,442.856781 445.724945,442.718689 444.331818,442.462891 
	C451.368134,439.596130 458.788727,436.847107 466.209320,434.098083 
	C466.398560,434.522980 466.587799,434.947876 466.777008,435.372772 
	C458.443115,441.381622 449.062225,445.410400 439.009857,448.875610 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M525.225098,360.555298 
	C528.049438,359.054230 531.453857,355.866913 534.367920,356.265411 
	C540.682922,357.128937 545.933350,355.173401 551.748596,353.038055 
	C547.190308,356.117706 542.407288,358.515259 536.020874,357.371155 
	C532.830444,356.799622 529.080078,359.354248 525.225098,360.555298 
z"
          />
          <path
            fill="#4891BC"
            opacity="1.000000"
            stroke="none"
            d="
M637.470520,229.097961 
	C637.810425,229.462906 637.896240,229.682053 637.940247,230.252502 
	C633.822388,232.033997 629.746277,233.464172 625.670227,234.894348 
	C625.456482,234.311890 625.242798,233.729431 625.029053,233.146973 
	C629.091553,231.748688 633.153992,230.350418 637.470520,229.097961 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M526.880127,382.643494 
	C518.895386,379.268341 517.347290,368.269867 524.234253,360.890137 
	C519.098206,370.781952 519.525452,374.970642 526.880127,382.643494 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M694.526611,220.292847 
	C688.847534,220.664413 682.836548,220.825317 676.497192,220.759644 
	C682.177551,220.382782 688.186096,220.232483 694.526611,220.292847 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M598.770508,339.629883 
	C594.932007,342.750977 590.768250,345.887817 586.250061,348.964417 
	C590.078857,345.818024 594.262085,342.731812 598.770508,339.629883 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M436.566162,443.390503 
	C431.825500,443.841064 426.747986,444.079285 421.374084,444.046051 
	C426.128235,443.575775 431.178772,443.376984 436.566162,443.390503 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M661.380005,226.208740 
	C664.486145,225.851715 667.953674,225.630600 671.693848,225.708588 
	C668.558167,226.119995 665.149780,226.232346 661.380005,226.208740 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M698.562622,281.212921 
	C700.185486,277.922333 702.108582,274.485779 704.359131,271.005493 
	C702.745300,274.330139 700.804138,277.698547 698.562622,281.212921 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M706.815063,224.703766 
	C703.687561,223.801987 700.421936,222.604553 697.025146,221.112488 
	C700.154907,222.014587 703.415894,223.211349 706.815063,224.703766 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M399.841858,428.051483 
	C399.415710,424.909607 399.065155,421.277771 398.975891,417.362793 
	C399.463959,420.573608 399.690735,424.067566 399.841858,428.051483 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M554.698120,369.337738 
	C552.827576,371.500366 550.619568,373.693695 548.131836,375.996979 
	C550.021545,373.860779 552.191101,371.614624 554.698120,369.337738 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M575.800903,355.784424 
	C573.681335,357.602417 571.252319,359.337952 568.478027,361.053101 
	C570.585693,359.255798 573.038513,357.478851 575.800903,355.784424 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M675.708313,226.670715 
	C678.639526,227.622040 681.845337,228.784073 685.092773,230.294373 
	C682.083862,229.388916 679.033386,228.135178 675.708313,226.670715 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M536.582886,385.037598 
	C533.985535,384.817291 531.035706,384.488068 528.007202,383.819336 
	C530.695862,383.962769 533.463135,384.445740 536.582886,385.037598 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M708.463013,264.063538 
	C709.338989,261.227875 710.482361,258.197083 711.912842,255.032562 
	C711.043396,257.888702 709.886902,260.878571 708.463013,264.063538 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M654.777710,295.307983 
	C653.325195,297.169983 651.555420,299.092224 649.448608,301.005280 
	C650.894592,299.120148 652.677490,297.244202 654.777710,295.307983 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M619.768188,324.589966 
	C618.274475,326.050751 616.460938,327.528473 614.304443,328.974609 
	C615.790466,327.497620 617.619446,326.052307 619.768188,324.589966 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M715.096008,239.667236 
	C714.345703,237.827560 713.728333,235.697678 713.135010,233.181885 
	C713.848999,234.989639 714.538940,237.183334 715.096008,239.667236 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M400.045258,414.906891 
	C400.534027,412.617554 401.303040,410.185455 402.373016,407.554840 
	C401.891174,409.825623 401.108307,412.294861 400.045258,414.906891 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M669.639282,279.047302 
	C668.644226,280.691040 667.326843,282.389130 665.677795,284.104370 
	C666.669739,282.448273 667.993286,280.774963 669.639282,279.047302 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M679.711548,265.181396 
	C679.113159,266.727448 678.214722,268.362549 677.011963,270.054871 
	C677.608948,268.498199 678.510193,266.884338 679.711548,265.181396 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M402.829163,433.888855 
	C401.777283,432.749603 400.782806,431.246735 399.799561,429.375305 
	C400.836060,430.512878 401.861298,432.019073 402.829163,433.888855 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M660.680908,289.157379 
	C659.957764,290.407379 658.928345,291.732056 657.567810,293.073547 
	C658.282715,291.804230 659.328613,290.518158 660.680908,289.157379 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M411.866302,440.762817 
	C410.354156,440.322083 408.699951,439.563263 406.929504,438.484314 
	C408.450256,438.924377 410.087250,439.684601 411.866302,440.762817 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M406.083191,400.775726 
	C406.578796,399.249084 407.425323,397.653259 408.591827,395.939056 
	C408.085876,397.449310 407.260010,399.077911 406.083191,400.775726 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M411.133789,392.805298 
	C411.579315,391.581696 412.365112,390.272491 413.469849,388.866943 
	C413.017212,390.086975 412.245636,391.403351 411.133789,392.805298 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M542.803650,382.459595 
	C541.889832,383.272583 540.657776,384.128387 539.085449,384.895752 
	C539.991943,384.039032 541.238708,383.270721 542.803650,382.459595 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M712.574707,230.761566 
	C711.658752,230.080048 710.753418,229.099304 709.879883,227.805130 
	C710.802917,228.481903 711.694031,229.472122 712.574707,230.761566 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M562.784241,364.380371 
	C561.945557,365.255157 560.783264,366.135437 559.286011,366.976501 
	C560.120911,366.086761 561.290771,365.236328 562.784241,364.380371 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M705.367432,269.952240 
	C705.638245,268.765747 706.182861,267.431610 707.024658,266.000885 
	C706.761719,267.204407 706.201538,268.504486 705.367432,269.952240 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M688.512451,242.822418 
	C688.669312,243.910431 688.611023,245.192581 688.252319,246.725861 
	C688.067078,245.656845 688.182190,244.336716 688.512451,242.822418 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M690.391907,293.021118 
	C690.679749,292.080292 691.256836,291.042969 692.148560,289.960938 
	C691.869202,290.919006 691.275208,291.921814 690.391907,293.021118 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M672.752441,275.232544 
	C672.455261,276.083191 671.889954,277.053223 671.033936,278.070862 
	C671.323608,277.196289 671.903992,276.274139 672.752441,275.232544 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M623.767822,321.472595 
	C623.231140,322.327667 622.394043,323.166626 621.235413,323.961243 
	C621.765076,323.096771 622.616211,322.276611 623.767822,321.472595 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M643.746582,305.347076 
	C643.307739,306.245361 642.570435,307.152313 641.515991,308.038879 
	C641.948608,307.130920 642.698425,306.243347 643.746582,305.347076 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M414.071472,388.790100 
	C414.318024,387.760925 414.890686,386.674500 415.770142,385.543518 
	C415.517151,386.576935 414.957367,387.654877 414.071472,388.790100 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M441.778259,442.625061 
	C441.145813,443.064819 440.346069,443.285950 439.250763,443.348175 
	C439.840454,442.928284 440.725739,442.667358 441.778259,442.625061 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M433.808105,450.814148 
	C434.711700,450.138184 435.990814,449.534760 437.632507,448.963928 
	C436.724579,449.626587 435.454102,450.256653 433.808105,450.814148 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M687.772217,235.217987 
	C688.213318,235.886017 688.574036,236.862961 688.792419,238.155212 
	C688.330688,237.489334 688.011292,236.508118 687.772217,235.217987 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M714.781555,246.713287 
	C714.550598,246.038956 714.509583,245.190689 714.710632,244.193619 
	C714.958984,244.876312 714.965210,245.707840 714.781555,246.713287 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M404.081360,404.743103 
	C404.216187,403.575867 404.682587,402.291901 405.470947,400.886871 
	C405.332947,402.052673 404.872955,403.339539 404.081360,404.743103 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M584.788574,349.484741 
	C584.575623,349.990967 584.083923,350.522949 583.296143,351.010101 
	C583.503296,350.480316 584.006653,349.995392 584.788574,349.484741 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M675.708862,271.078064 
	C675.689514,271.695953 675.393127,272.352600 674.807068,273.044922 
	C674.822144,272.425995 675.127014,271.771423 675.708862,271.078064 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M636.800903,311.453308 
	C636.628967,312.025238 636.185974,312.561371 635.457764,313.072418 
	C635.624939,312.504059 636.077393,311.960785 636.800903,311.453308 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M630.798950,316.494263 
	C630.598389,317.017395 630.122070,317.549347 629.353027,318.039124 
	C629.547852,317.498993 630.035461,317.001068 630.798950,316.494263 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M581.807129,351.501770 
	C581.608582,352.057281 581.139954,352.574738 580.387939,353.055267 
	C580.582092,352.500153 581.059509,351.981934 581.807129,351.501770 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M685.587158,253.915710 
	C685.694763,254.471054 685.559753,255.162766 685.169128,255.978348 
	C685.057190,255.418839 685.200806,254.735474 685.587158,253.915710 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M713.353516,252.013672 
	C713.242615,251.492294 713.363098,250.838196 713.713257,250.047775 
	C713.823547,250.567947 713.704163,251.224457 713.353516,252.013672 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M687.447388,248.739960 
	C687.582336,249.341110 687.469421,250.095474 687.077515,250.975830 
	C686.932190,250.365585 687.065796,249.629395 687.447388,248.739960 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M626.777344,319.407166 
	C626.576904,319.958496 626.091797,320.483643 625.308960,320.989624 
	C625.505005,320.440674 625.998901,319.910858 626.777344,319.407166 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M601.767212,337.340149 
	C601.576721,337.936523 601.104126,338.502991 600.331299,339.025513 
	C600.515747,338.424469 601.000427,337.867340 601.767212,337.340149 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M685.407227,231.150314 
	C685.931213,231.367615 686.480896,231.873856 686.998657,232.688995 
	C686.455444,232.478333 685.944214,231.958786 685.407227,231.150314 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M605.827515,334.659058 
	C605.597107,335.167450 605.094971,335.628571 604.316284,336.038086 
	C604.545044,335.528259 605.050415,335.070007 605.827515,334.659058 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M608.851318,332.537811 
	C608.621094,333.023102 608.106201,333.537659 607.294434,334.008179 
	C607.520691,333.498505 608.043701,333.032776 608.851318,332.537811 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M709.035706,226.607513 
	C708.408875,226.510361 707.729980,226.104477 707.030396,225.365005 
	C707.667664,225.453857 708.325623,225.876312 709.035706,226.607513 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M612.784302,329.425140 
	C612.614502,329.982025 612.169189,330.536835 611.428772,331.061554 
	C611.591980,330.495331 612.050415,329.959198 612.784302,329.425140 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M546.675964,378.058289 
	C546.617981,378.638458 546.302185,379.332306 545.666138,380.036621 
	C545.703308,379.422028 546.060669,378.796997 546.675964,378.058289 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M414.927979,442.130371 
	C414.300262,442.208405 413.555878,441.992523 412.656921,441.496368 
	C413.271973,441.422882 414.041656,441.629669 414.927979,442.130371 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M418.981934,443.166016 
	C418.488708,443.416656 417.923279,443.427734 417.186188,443.190704 
	C417.646240,442.937195 418.278015,442.931824 418.981934,443.166016 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M681.204590,304.727722 
	C681.280273,304.203339 681.602051,303.574707 682.210938,302.932678 
	C682.148987,303.487335 681.799805,304.055420 681.204590,304.727722 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M684.303040,300.913147 
	C684.365356,300.304932 684.707703,299.633453 685.354004,298.928711 
	C685.299622,299.546936 684.941284,300.198425 684.303040,300.913147 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M687.377686,297.031372 
	C687.434204,296.412292 687.772583,295.718475 688.424561,294.997955 
	C688.378723,295.633057 688.019226,296.294861 687.377686,297.031372 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M656.820312,293.321106 
	C656.678467,293.862915 656.260925,294.470917 655.544678,295.087769 
	C655.678894,294.526825 656.111755,293.957062 656.820312,293.321106 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M409.597290,394.964661 
	C409.609100,394.336853 409.930511,393.649384 410.548004,392.885040 
	C410.531677,393.507111 410.219269,394.206055 409.597290,394.964661 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M693.315552,288.948944 
	C693.333252,288.334839 693.626160,287.658844 694.214966,286.952759 
	C694.204102,287.577454 693.897400,288.232239 693.315552,288.948944 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M695.361084,286.002502 
	C695.407776,285.399170 695.725769,284.702484 696.357910,283.981567 
	C696.325500,284.607910 695.978943,285.258514 695.361084,286.002502 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M664.895630,284.480652 
	C664.810425,284.962494 664.482605,285.520447 663.893677,286.089905 
	C663.972717,285.586517 664.312866,285.071655 664.895630,284.480652 
z"
          />
          <path
            fill="#243247"
            opacity="1.000000"
            stroke="none"
            d="
M557.780273,367.449982 
	C557.524780,367.983246 556.983521,368.489197 556.142578,368.933502 
	C556.393311,368.388794 556.943909,367.905731 557.780273,367.449982 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M403.035797,406.857910 
	C402.892456,406.387817 403.059662,405.771851 403.506287,404.988647 
	C403.639221,405.451569 403.492798,406.081818 403.035797,406.857910 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M403.745178,434.990112 
	C403.467621,435.094818 403.155151,434.911835 402.792786,434.450439 
	C403.065338,434.348816 403.387848,434.525604 403.745178,434.990112 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M406.805939,437.919495 
	C406.553131,438.038116 406.228088,437.883820 405.829681,437.458435 
	C406.082092,437.340393 406.407928,437.493469 406.805939,437.919495 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M405.768402,436.963776 
	C405.503845,437.073639 405.191833,436.901306 404.814758,436.459076 
	C405.073456,436.353302 405.397186,436.517456 405.768402,436.963776 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M404.763458,435.966980 
	C404.497131,436.086273 404.181458,435.921417 403.793915,435.489502 
	C404.052734,435.375885 404.383392,435.529327 404.763458,435.966980 
z"
          />
          <path
            fill="#F4F5F6"
            opacity="1.000000"
            stroke="none"
            d="
M597.084595,546.539673 
	C595.658997,551.507080 591.869934,549.752991 589.039490,549.829895 
	C581.195496,550.043335 581.179810,549.901123 581.176331,541.953186 
	C581.173706,535.968445 581.309875,529.981384 581.178894,523.999878 
	C581.114197,521.043945 582.199097,519.908997 585.188354,519.715027 
	C597.113037,518.941101 597.116455,518.862061 597.154663,530.625610 
	C597.171387,535.778931 597.145203,540.932373 597.084595,546.539673 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M524.920959,519.697083 
	C528.305115,519.727661 529.510986,521.174561 529.270447,524.090759 
	C529.107910,526.061462 529.020935,528.084167 529.276917,530.034180 
	C529.870972,534.560242 527.808838,535.476929 523.617004,535.609253 
	C518.582581,535.768188 516.482544,534.193237 517.258484,529.150208 
	C517.382935,528.341614 517.291931,527.499573 517.296265,526.672974 
	C517.332520,519.784546 517.332214,519.784546 524.920959,519.697083 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M775.103149,536.219849 
	C773.037170,536.245605 771.421936,536.245605 768.212158,536.245605 
	C770.698975,531.288147 772.616577,527.281189 774.800903,523.425293 
	C774.997009,523.079102 777.582458,523.335571 777.930054,523.950134 
	C779.915894,527.461670 781.559814,531.166504 783.991455,536.194092 
	C780.241882,536.194092 777.897888,536.194092 775.103149,536.219849 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M658.985352,532.105957 
	C658.652710,533.722168 658.275574,536.008606 657.699890,536.059692 
	C653.997620,536.388428 650.251892,536.227661 645.058228,536.227661 
	C647.442078,531.252197 649.142151,527.410034 651.225464,523.788269 
	C651.445618,523.405579 654.550293,523.841370 655.219299,524.726746 
	C656.783936,526.797241 657.681396,529.371887 658.985352,532.105957 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M464.813965,526.173401 
	C469.765381,536.604309 469.440857,536.983398 458.337677,536.407959 
	C454.472321,536.207642 454.236176,534.415894 455.479584,531.586243 
	C456.341858,529.623901 457.386688,527.738525 458.407715,525.849976 
	C460.752106,521.513550 461.634552,521.517029 464.813965,526.173401 
z"
          />
          <path
            fill="#ECEEF2"
            opacity="1.000000"
            stroke="none"
            d="
M591.882019,596.676331 
	C596.431763,598.955933 597.320374,603.094421 594.563599,605.763672 
	C592.318787,607.937256 587.825317,607.863220 584.273621,608.450745 
	C584.026367,608.491638 582.953674,605.764587 582.884583,604.295532 
	C582.473450,595.553284 582.834351,595.283081 591.882019,596.676331 
z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
